import React, { useState, useRef, useEffect } from "react";
import Grid from "@mui/material/Grid";
import FloatLabel from "../../../UiComponents/FloatLabel/FloatLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import {
  GetUser,
  GetCompany,
  GetProduct,
  GetPolicyType,
  GetSubProduct,
  GetBookingCode,
  GetSubBookingCode,
  GetFuelType,
  GetUserpayablePercentage,
  GetBranchpayablePercentage,
  GetReceivablePayablePercentage,
  GetPolicyFileById,
  ReadPolicyFileByPolicyId,
  GetVehicleMake,
  LoginPortalData,
} from "../../../Service/_index";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import CloseIcon from "@mui/icons-material/Close";
import Autocomplete from "@mui/material/Autocomplete";
import moment from "moment/moment";
import dayjs from "dayjs";
import Button from "@mui/material/Button";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import DescriptionSharpIcon from "@mui/icons-material/DescriptionSharp";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import * as Yup from "yup";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Formik, Form, Field, useFormikContext } from "formik";
import { UpdatePolicyList } from "../../../Service/_index";
import { ToastError } from "../../../UiComponents/Toaster/Toast";
import { PolicyFilterTypes } from "../../../Shared/CommonConstant";
import { CalculateIcon } from "../../../Resources/Icons/icons";
import Loader from "../../../UiComponents/Loader/Loader";
import { GetRTOList } from "../../../Service/RTOService";
import Styles from "../../../UiComponents/Scss/CommonDrawer.module.scss";
import { Divider } from "@mui/material";
import { RemoveRedEyeIcon } from "../../../Resources/Icons/icons";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useNavigate } from "react-router-dom";

const PaymentDetails = [
  {
    label: "Cash",
    value: 1,
  },
  {
    label: "Online",
    value: 2,
  },
  {
    label: "Cheque",
    value: 3,
  },
  {
    label: "DD",
    value: 4,
  },
];

const OdPolicyPeriodController = [
  {
    label: "1",
    value: 1,
  },
  {
    label: "2",
    value: 2,
  },
  {
    label: "3",
    value: 3,
  },
  {
    label: "4",
    value: 4,
  },
  {
    label: "5",
    value: 5,
  },
];

const validationSchema = Yup.object().shape({
  bookingCodeId: Yup.string().required("Bookingcode Required"),
  subBookingCodeId: Yup.string().required("Sub Bookingcode Required"),
  policyTypeId: Yup.string().required("Policytype Required"),
  productId: Yup.string().required("Product Required"),
  companyId: Yup.string().required("Company Required"),
  subProductId: Yup.string().required("Sub Product Required"),
  customerName: Yup.string().required("CustomerName Required"),
  mobileNumber: Yup.string().required("Mobile Number Required"),
  email: Yup.string().required("Email Required"),
  registrationNumber: Yup.string().required("Reg Number Required"),
  make: Yup.string().required("Make  Required"),
  model: Yup.string().required("Model Required"),
  cc: Yup.string().required("CC Required"),
  gvw: Yup.string().required("GVW Required"),
  seatingCapacity: Yup.string().required("Seating Capacity Required"),
  registrationYear: Yup.string().required("Registeration Year Required"),
  fuelType: Yup.string().required("Fuel type Required"),
  odPolicyStartDate: Yup.string().required("OD Policy Startdate Required"),
  odPolicyPeriod: Yup.string().required("OD Policy Period Required"),
  odDisc: Yup.string().required("OD Disc Required"),
  odPremium: Yup.string().required("OD Premium Required"),
  tpPremium: Yup.string().required("TP Premium Required"),
  netPremium: Yup.string().required("Net Premium Required"),
  totalPremium: Yup.string().required("Total Premium Required"),
  paCover: Yup.string().required("PA Cover Required"),
});

const initialValues = {
  userId: "",
  loginIdFull: "",
  companyId: "",
  productId: "",
  subProductId: "",
  policyTypeId: "",
  bookingCodeId: "",
  subBookingCodeId: "",
  policyNumber: "",
  customerName: "",
  mobileNumber: "",
  email: "",
  registrationNumber: "",
  make: "",
  model: "",
  seatingCapacity: "",
  cc: "",
  gvw: "",
  registrationYear: "",
  odDisc: "",
  odPremium: "",
  tpPremium: "",
  netPremium: "",
  totalPremium: "",
  paCover: "",
  paymentMode: "",
  fuelType: "",
  odPolicyStartDate: new Date(),
  odPolicyPeriod: "",
  odPolicyEndDate: new Date(),
  tpPolicyStartDate: new Date(),
  tpPolicyPeriod: "",
  tpPolicyEndDate: new Date(),
  issueDate: new Date(),
  chequeDate: new Date(),
  bankName: "",
  chequeNumber: "",
  checkedNumber: "", //it is a entry pending checking number
  rejectedReason: "",
  userOdPercentage: "",
  userTpPercentage: "",
  userNetPercentage: "",
  userOdAmount: "",
  userTpAmount: "",
  userNetAmount: "",
  userTotalPayable: "",
  branchOdPercentage: "",
  branchTpPercentage: "",
  branchNetPercentage: "",
  branchOdAmount: "",
  branchTpAmount: "",
  branchNetAmount: "",
  branchTotalPayabl: "",
  receivableOdPercentage: "",
  receivableTpPercentage: "",
  receivableNetPercentage: "",
  receivableOdAmount: "",
  receivableTpAmount: "",
  receivableNetAmount: "",
  receivableTotalPayabl: "",
  rtoId: "", //Changes by Arun
};

const EditSearchPolicy = (props) => {
  let formRef = useRef();
  const {
    setOpenEditPolicyDrawer,
    selectedData,
    formType,
    GetData,
    editType,
    openEditPolictDrawer,
    type,
    input,
  } = props;

  const navigate = useNavigate();

  const [userDetails, setUserDetails] = useState([]);
  const [companyDetails, setCompanyDetails] = useState([]);
  const [productDetails, setProductDetails] = useState([]);
  const [subProductDetails, setSubProductDetails] = useState([]);
  const [subBookingCodeDetails, setSubBookingCodeDetails] = useState([]);
  const [policyTypeDetails, setPolicyTypeDetails] = useState([]);
  const [bookingCodeDetails, setBookingCodeDetails] = useState([]);
  const [fuelType, setFuelType] = useState([]);
  const [openLoader, setOpenLoader] = useState(false);
  const [showPaymentMethod, setShowPaymentMethod] = useState(
    selectedData?.paymentMode === "cheque" ? 3 : null
  );
  const [disableOne, setDisableOne] = useState(true);

  const [userValue, setUserValue] = useState(
    formType === "edit" ? selectedData?.userId?.name : null
  );
  const [companyValue, setCompanyValue] = useState(
    formType === "edit" ? selectedData?.companyId?.shortName : null
  );
  const [productValue, setProductValue] = useState(
    formType === "edit" ? selectedData?.productId?.product : null
  );
  const [subProductValue, setSubProductValue] = useState(
    formType === "edit" ? selectedData?.subProductId?.subProduct : null
  );
  const [policyTypeValue, setPolicyTypeValue] = useState(
    formType === "edit" ? selectedData?.policyTypeId?.policyType : null
  );
  const [bookingCodeValue, setBookingCodeValue] = useState(
    formType === "edit" ? selectedData?.bookingCodeId?.bookingCode : null
  );
  const [fuelTypeValue, setFuelTypeValue] = useState(
    formType === "edit" ? selectedData?.fuelType?.fuelType : null
  );
  const [subBookingCodeValue, setSubBookingCodeValue] = useState(
    formType === "edit" ? selectedData?.subBookingCodeId?.subBookingCode : null
  );

  const [odPolicyEndDateValue, setOdPolicyEndDateValue] = React.useState(
    formType === "edit" ? dayjs(selectedData?.odPolicyEndDate) : null
  );
  const [tpPolicyDate, settpPolicyDate] = React.useState(
    formType === "edit" ? dayjs(selectedData?.tpPolicyEndDate) : null
  );
  const [editableData, setEditableData] = useState(
    selectedData.status === PolicyFilterTypes[2].value ? true : false
  );
  const [value, setValue] = React.useState(1);
  const [showPolUpTable, setShowPolUpTable] = useState(false);
  const [showRejectField, setShowRejectField] = useState(false);
  const [approveKey, setApproveKey] = useState(null);
  const [openViewCal, setOpenViewCal] = useState(false);
  const [fillIssueDate, setFillIssueDate] = useState(
    dayjs(selectedData?.issueDate)
  );
  const [selectedCompany, setSelectedCompany] = useState(companyValue);
  const [rtoList, setRTOList] = useState([]); // Changes by Arun
  const [rtoListDropdown, setRTOListDropdown] = useState([]); // Changes by Arun
  const [rtoValue, setRtoValue] = useState(null); // Changes by Arun
  const [rtoIdValue, setRtoIdValue] = useState(null); // Changes by Arun

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangePerTap = (e, newValue) => {
    setValue(Number(newValue) + 1);
  };

  const GetUserDetails = () => {
    GetUser({ isAscending: true }).then((res) => {
      const modifiedUserDetails = res.data.map((e) => {
        return {
          ...e,
          label: e.name,
          value: e._id,
        };
      });
      setUserDetails(modifiedUserDetails);
    });
  };
  const GetCompanyDetails = () => {
    GetCompany({ isAscending: true }).then((res) => {
      const modifiedCompanyDetails = res.data
        .map((e) => {
          if (e.isEnabled) {
            return {
              ...e,
              label: e.shortName,
              value: e._id,
            };
          } else {
            return null;
          }
        })
        .filter(Boolean);
      setCompanyDetails(modifiedCompanyDetails);
    });
  };

  const GetPolicyDetails = () => {
    GetPolicyType({ isAscending: true }).then((res) => {
      const modifiedPolicyTypeDetails = res.data
        .map((e) => {
          if (e.isEnabled) {
            return {
              ...e,
              label: e.policyType,
              value: e._id,
            };
          } else {
            return null;
          }
        })
        .filter(Boolean);
      setPolicyTypeDetails(modifiedPolicyTypeDetails);
    });
  };

  const GetBookingCodeDetails = () => {
    GetBookingCode({ isAscending: true }).then((res) => {
      const modifiedBookingCodeDetails = res.data
        .map((e) => {
          if (e.isEnabled) {
            return {
              ...e,
              label: e.bookingCode,
              value: e._id,
            };
          } else {
            return null;
          }
        })
        .filter(Boolean);
      setBookingCodeDetails(modifiedBookingCodeDetails);
    });
  };

  const GetFuelTypeDetails = () => {
    GetFuelType().then((res) => {
      const modifiedFuelTypeDetails = res.data
        .map((e) => {
          if (e.isEnabled) {
            return {
              ...e,
              label: e.fuelType,
              value: e._id,
            };
          } else {
            return null;
          }
        })
        .filter(Boolean);
      setFuelType(modifiedFuelTypeDetails);
    });
  };

  const GetProductDetails = () => {
    GetProduct({ isAscending: true }).then((res) => {
      const modifiedProductDetails = res.data
        .map((e) => {
          if (e.isEnabled) {
            return {
              ...e,
              label: e.product,
              value: e._id,
            };
          } else {
            return null;
          }
        })
        .filter(Boolean);
      setProductDetails(modifiedProductDetails);
    });
  };

  const GetSubProductDetails = () => {
    GetSubProduct({ isAscending: true }).then((res) => {
      const modifiedSubProductDetails = res.data
        .map((e) => {
          if (e.isEnabled) {
            return {
              ...e,
              label: e.subProduct,
              value: e._id,
            };
          } else {
            return null;
          }
        })
        .filter(Boolean);

      const FilterSubProductDetails = modifiedSubProductDetails.filter(
        (item) => item.product === productValue
      );
      setSubProductDetails(FilterSubProductDetails);
    });
  };

  //vehicleMake added by gokul..

  const [productIdValue, setProductIdValue] = useState(
    formType === "edit" ? selectedData?.productId?._id : null
  );
  const [subProductIdValue, setSubProductIdValue] = useState(
    formType === "edit" ? selectedData?.subProductId?._id : null
  );
  const [vehicleMakeDetails, setVehicleMakeDetails] = useState([]);
  const [vehicleValue, setVehicleValue] = useState(
    formType === "edit" ? selectedData?.make?.vehicleMake : null
  );

  const GetVehicleMakeDetails = () => {
    GetVehicleMake({ isAscending: true }).then((res) => {
      const modifiedVehicleMakeDetails = res.data
        .map((e) => {
          if (e.isEnabled) {
            return {
              ...e,
              label: e.vehicleMake,
              value: e._id,
            };
          } else {
            return null;
          }
        })
        .filter(Boolean);
      const data = modifiedVehicleMakeDetails.filter((n) => {
        if (n.productID === productIdValue) {
          return n;
        }
      });
      setVehicleMakeDetails(data);
    });
  };

  // loginPortal added by gokul...

  const [selectedUserId, setSelectedUserId] = useState(
    formType === "edit" ? selectedData?.userId?._id : null
  );
  const [selectedCompanyId, setSelectedCompanyId] = useState(
    formType === "edit" ? selectedData?.companyId?._id : null
  );
  const [selectedLoginPortal, setSelectedLoginPortal] = useState(
    formType === "edit" ? selectedData?.loginIdFull : null
  );
  const [loginPortalDetails, setLoginPortalDetails] = useState([]);

  const GetLoginPortalData = () => {
    LoginPortalData({
      userId: selectedUserId,
      companyId: selectedCompanyId,
      isActive: true,
    }).then((res) => {
      const filterData1 = res?.data.filter((item) => {
        if (item?.userId === selectedUserId) {
          if (item?.companyId === selectedCompanyId) {
            return item;
          }
        }
      });
      const UserAllData = res?.data.filter((item) => {
        if (item?.userId === "All") {
          if (item?.companyId === selectedCompanyId) {
            return item;
          }
        }
      });

      const UserAdminData = res?.data.filter((item) => {
        if (item?.userId === "Admin") {
          if (item?.companyId === selectedCompanyId) {
            return item;
          }
        }
      });
      setLoginPortalDetails([...filterData1, ...UserAllData, ...UserAdminData]);
    });
  };

  useEffect(() => {
    console.log("use effect 3");

    if (selectedUserId) GetLoginPortalData();
    else setLoginPortalDetails([]);
  }, [selectedUserId, selectedCompanyId]);

  useEffect(() => {
    console.log("use effect 5");

    GetVehicleMakeDetails();
  }, [productIdValue]);
  useEffect(() => {
    console.log("use effect 6");

    GetSubProductDetails();
  }, [productValue]);

  const GetSubBookingCodeDetails = () => {
    GetSubBookingCode({ isAscending: true }).then((res) => {
      const modifiedSubBookingCodeDetails = res.data
        .map((e) => {
          if (e.isEnabled) {
            return {
              ...e,
              label: e.subBookingCode,
              value: e._id,
            };
          } else {
            return null;
          }
        })
        .filter(Boolean);
      const FilterSubBookingCodeDetails = modifiedSubBookingCodeDetails.filter(
        (item) => item.bookingCode === bookingCodeValue
      );
      setSubBookingCodeDetails(FilterSubBookingCodeDetails);
    });
  };

  useEffect(() => {
    console.log("use effect 1");
    GetSubBookingCodeDetails();
  }, [bookingCodeValue]);

  useEffect(() => {
    console.log("use effect 2");

    // Changes by Arun
    const getRtoList = async () => {
      await GetRTOList().then((res) => {
        setRTOList(res?.data || []);
        if (selectedData.rtoId) {
          const findDoc = res.data.find((element) => {
            if (element._id == selectedData.rtoId) return element;
          });
          setRtoValue(findDoc?.label);
          setRtoIdValue(findDoc._id);
        }
        checkRTO(res?.data, selectedData?.registrationNumber); //Changes by Arun
      });
    };
    getRtoList(); //Changes by Arun

    GetUserDetails();
    GetCompanyDetails();
    GetProductDetails();
    GetPolicyDetails();
    GetBookingCodeDetails();
    GetFuelTypeDetails();
    if (formType === "edit") {
      console.log("Data:", selectedData);
      formRef.setFieldValue("userId", selectedData?.userId?._id);
      formRef.setFieldValue("loginIdFull", selectedData?.loginIdFull);
      formRef.setFieldValue("companyId", selectedData?.companyId?._id);
      formRef.setFieldValue("productId", selectedData?.productId?._id);
      formRef.setFieldValue("policyTypeId", selectedData?.policyTypeId?._id);
      formRef.setFieldValue("bookingCodeId", selectedData?.bookingCodeId?._id);
      formRef.setFieldValue("subProductId", selectedData?.subProductId?._id);
      formRef.setFieldValue(
        "subBookingCodeId",
        selectedData?.subBookingCodeId?._id
      );
      formRef.setFieldValue("policyNumber", selectedData?.policyNumber);
      formRef.setFieldValue("customerName", selectedData?.customerName);
      formRef.setFieldValue("mobileNumber", selectedData?.mobileNumber);
      formRef.setFieldValue("email", selectedData?.email);
      formRef.setFieldValue("make", selectedData?.make?._id);
      formRef.setFieldValue("model", selectedData?.model);
      formRef.setFieldValue("seatingCapacity", selectedData?.seatingCapacity);
      formRef.setFieldValue("cc", selectedData?.cc);
      formRef.setFieldValue("gvw", selectedData?.gvw);
      formRef.setFieldValue("registrationYear", selectedData?.registrationYear);
      formRef.setFieldValue("odDisc", selectedData?.odDisc);
      formRef.setFieldValue("odPremium", selectedData?.odPremium);
      formRef.setFieldValue("tpPremium", selectedData?.tpPremium);
      formRef.setFieldValue("netPremium", selectedData?.netPremium);
      formRef.setFieldValue("fuelType", selectedData?.fuelType?._id);
      formRef.setFieldValue("totalPremium", selectedData?.totalPremium);
      formRef.setFieldValue("paCover", selectedData?.paCover);
      formRef.setFieldValue("paymentMode", selectedData?.paymentMode);
      formRef.setFieldValue("issueDate", selectedData?.issueDate);
      formRef.setFieldValue("chequeNumber", selectedData?.chequeNumber);
      formRef.setFieldValue("bankName", selectedData?.bankName);
      formRef.setFieldValue("chequeDate", selectedData?.chequeDate);
      formRef.setFieldValue("status", selectedData?.status);
      formRef.setFieldValue(
        "odPolicyStartDate",
        selectedData?.odPolicyStartDate
      );
      formRef.setFieldValue("odPolicyEndDate", selectedData?.odPolicyEndDate);
      formRef.setFieldValue("odPolicyPeriod", selectedData?.odPolicyPeriod);
      formRef.setFieldValue(
        "tpPolicyStartDate",
        selectedData?.tpPolicyStartDate
      );
      formRef.setFieldValue("tpPolicyEndDate", selectedData?.tpPolicyEndDate);
      formRef.setFieldValue("tpPolicyPeriod", selectedData?.tpPolicyPeriod);
      formRef.setFieldValue(
        "registrationNumber",
        selectedData?.registrationNumber
      );
      formRef.setFieldValue("rtoId", selectedData?.rtoId || ""); // Changes by Arun
    }
  }, []);

  // Changes by Arun
  const checkRTO = (tempRtoList, registrationNumber) => {
    console.log("registrationNumber ", registrationNumber);
    if (!registrationNumber) {
      return true;
    }
    const regNumber = registrationNumber.replace("-", "");
    const firstFourChar = regNumber.substring(0, 4);
    // console.log("firstFourChar ", firstFourChar);
    // console.log("tempRtoList ", tempRtoList);
    const findDoc = tempRtoList.find((element) => {
      if (element.label == firstFourChar.toUpperCase()) return element;
    });
    if (findDoc) {
      setRTOListDropdown([findDoc]);
      formRef.setFieldValue("rtoId", findDoc._id);
      setRtoValue(findDoc?.label);
      setRtoIdValue(findDoc._id);
    } else {
      setRTOListDropdown(tempRtoList);
    }
  };

  const PaymentFunction = (e) => {
    setShowPaymentMethod(e.value);
    formRef.setFieldValue("paymentMode", e.label);
  };
  const UserName = sessionStorage.getItem("UserId");
  const onSubmit = (data) => {
    if (true) {
      const CurrentDate = new Date();
      // console.log("data?.policyNumber :::", data?.policyNumber);
      data.policyNumber = data?.policyNumber.replace(/[^a-zA-Z0-9/-]/g, "");
      // console.log("data?.policyNumber after:::", data?.policyNumber);
      // return true
      ["totalPremium", "registrationNumber", "cc", "gvw"].forEach(
        (item) => (data[item] = data[item]?.replace(/-/g, ""))
      );
      if (editType === "CommonEdit") {
        data.status = data.status;
      } else {
        if (data?.paymentMode === "Cheque" && approveKey) {
          data.status = PolicyFilterTypes[5].value;
        } else if (approveKey && !(data?.paymentMode === "Cheque")) {
          data.status = PolicyFilterTypes[2].value;
          data.isCloseDrawer = true;
          data.verifyPendingBy = UserName;
          data.verifyPendingAt = CurrentDate;
        } else if (data?.status === PolicyFilterTypes[2].value) {
          if (editableData) {
            if (data.userTotalPayable > 0) {
              data.isUserPayable = true;
              data.status = PolicyFilterTypes[4].value;
              data.userPayable = {
                ODPercentage: data?.userOdPercentage,
                TPPercentage: data?.userTpPercentage,
                NETPercentage: data?.userNetPercentage,
                ODAmount: data?.userOdAmount,
                TPAmount: data?.userTpAmount,
                NETAmount: data?.userNetAmount,
                Total: data?.userTotalPayable.replace(/,/g, ""),
                createdBy: UserName,
                createdAt: CurrentDate,
                updatedAt: CurrentDate,
                updatedBy: UserName,
              };
            } else {
              data.status = PolicyFilterTypes[3].value;
              data.approvePendingBy = UserName;
              data.approvePendingAt = CurrentDate;
            }
            data.isBranchPayable = data.branchTotalPayabl > 0 ? true : false;
            data.branchPayable = {
              ODPercentage: data?.branchOdPercentage,
              TPPercentage: data?.branchTpPercentage,
              NETPercentage: data?.branchNetPercentage,
              ODAmount: data?.branchOdAmount,
              TPAmount: data?.branchTpAmount,
              NETAmount: data?.branchNetAmount,
              Total: data?.branchTotalPayabl.replace(/,/g, ""),
              createdBy: UserName,
              createdAt: CurrentDate,
              updatedAt: CurrentDate,
              updatedBy: UserName,
            };
            data.isCommisionRecievable =
              data.receivableTotalPayabl > 0 ? true : false;
            data.commisionRecievable = {
              ODPercentage: data?.receivableOdPercentage,
              TPPercentage: data?.receivableTpPercentage,
              NETPercentage: data?.receivableNetPercentage,
              ODAmount: data?.receivableOdAmount,
              TPAmount: data?.receivableTpAmount,
              NETAmount: data?.receivableNetAmount,
              Total: data?.receivableTotalPayabl.replace(/,/g, ""),
              createdBy: UserName,
              createdAt: CurrentDate,
              updatedAt: CurrentDate,
              updatedBy: UserName,
            };
          } else {
            data.status = data.status;
          }
        } else {
          data.status = data?.status;
        }
      }
      data.updatedBy = UserName;
      data.updatedAt = CurrentDate;
      UpdatePolicyList(selectedData?._id, data).then((res) => {
        GetData({ searchType: type, textField: input });

        if (editableData) {
          setOpenEditPolicyDrawer(false);
        } else {
          if (res) {
            data.status === PolicyFilterTypes[2].value
              ? setEditableData(true)
              : setEditableData(false);
            data.status === PolicyFilterTypes[2].value
              ? setOpenEditPolicyDrawer(true)
              : setOpenEditPolicyDrawer(false);
            data.isCloseDrawer
              ? setOpenEditPolicyDrawer(false)
              : setOpenEditPolicyDrawer(true);
          } else {
            setOpenEditPolicyDrawer(true);
          }
        }
        setOpenEditPolicyDrawer(false);
      });
    } else {
      ToastError("Enter All Fields");
    }
  };

  const GetPayablePercentFunction = () => {
    setOpenViewCal(!openViewCal);
    GetUserpayablePercentage(selectedData?._id).then((res) => {
      formRef.setFieldValue("userOdPercentage", res.data.OD);
      formRef.setFieldValue("userTpPercentage", res.data.TP);
      formRef.setFieldValue("userNetPercentage", res.data.Net);
    });
    GetBranchpayablePercentage(selectedData?._id).then((res) => {
      formRef.setFieldValue("branchOdPercentage", res.data.OD);
      formRef.setFieldValue("branchTpPercentage", res.data.TP);
      formRef.setFieldValue("branchNetPercentage", res.data.Net);
    });
    GetReceivablePayablePercentage(selectedData?._id).then((res) => {
      formRef.setFieldValue("receivableOdPercentage", res.data.OD);
      formRef.setFieldValue("receivableTpPercentage", res.data.TP);
      formRef.setFieldValue("receivableNetPercentage", res.data.Net);
    });
  };

  const AutoFillFunction = () => {
    setOpenLoader(true);
    ReadPolicyFileByPolicyId(selectedData?._id).then((res) => {
      setOpenLoader(false);
      formRef.setFieldValue("cc", res?.data?.cc);
      formRef.setFieldValue("gvw", res?.data?.gvw);
      formRef.setFieldValue("policyNumber", res?.data?.policyNumber);
      formRef.setFieldValue(
        "registrationNumber",
        res?.data?.registrationNumber
      );
      formRef.setFieldValue("registrationYear", res?.data?.registrationYear);
      formRef.setFieldValue("seatingCapacity", res?.data?.seatingCapacity);
      formRef.setFieldValue(
        "totalPremium",
        String(res?.data?.totalPremium)?.replace(/,/g, "")
      );

      const ResCompany = res.data.companyName ? res.data.companyName : "";
      const foundCompany = companyDetails.find(
        (company) => company.companyName === ResCompany.toUpperCase()
      );
      if (res?.data?.issueDate) {
        const dateStr = res.data.issueDate;
        const daysjsDate = dayjs(dateStr, "DD/MM/YYYY");
        formRef.setFieldValue("issueDate", daysjsDate.$d);
        setFillIssueDate(daysjsDate);
      }
      if (foundCompany) {
        formRef.setFieldValue("companyId", foundCompany?.value);
        setSelectedCompany(foundCompany?.companyName);
      } else {
        formRef.setFieldValue("companyId", null);
        setSelectedCompany("");
        ToastError(
          `" ${ResCompany.toUpperCase()} "  Not added yet, Please add that Company !`
        );
      }
    });
  };
  const policyNumberChecking = (data) => {
    if (selectedData.policyNumber === data.checkedNumber) {
      setShowPolUpTable(true);
      setShowRejectField(false);
      setApproveKey("key_01");
    } else {
      ToastError("Policy Number Missmatching");
      setShowRejectField(true);
      setShowPolUpTable(false);
      setApproveKey(null);
    }
  };
  const RejectedFunction = (data) => {
    data.status = PolicyFilterTypes[6].value;
    data.rejectedReason = data?.rejectedReason;
    UpdatePolicyList(selectedData?._id, data).then((res) => {
      GetData({ searchType: type, textField: input });
      setOpenEditPolicyDrawer(false);
      ToastError("Rejected Succesfully");
    });
  };

  const ViewPdfFunction = () => {
    // setOpenLoader(true)
    GetPolicyFileById(selectedData?._id)
      .then((res) => {
        console.log(res.data);
        const pdfUrl = res?.data?.policyFile?.downloadURL;
        return pdfUrl;
      })
      .then((pdfUrl) => {
        console.log("url", pdfUrl);
        const blobData = base64toBlob(pdfUrl, "application/pdf");
        const blobUrl = URL.createObjectURL(blobData);
        // setOpenLoader(false)
        const pdfWindow = window.open("", "_blank");
        pdfWindow?.document?.write(
          // `<embed src="data:application/pdf;base64,${pdfUrl}" width="100%" height="100%" />`
          `<embed src="${blobUrl}" width="100%" height="100%" />`
        );
      });
  };

  const base64toBlob = (base64Data, contentType) => {
    contentType = contentType || "";
    var sliceSize = 1024;
    var byteCharacters = atob(base64Data);
    var bytesLength = byteCharacters.length;
    var slicesCount = Math.ceil(bytesLength / sliceSize);
    var byteArrays = new Array(slicesCount);

    for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
      var begin = sliceIndex * sliceSize;
      var end = Math.min(begin + sliceSize, bytesLength);

      var bytes = new Array(end - begin);
      for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
        bytes[i] = byteCharacters[offset].charCodeAt(0);
      }
      byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    return new Blob(byteArrays, { type: contentType });
  };

  const [odPolicyStartDate, setOdPolicyStartDate] = useState(
    formType === "edit" ? dayjs(selectedData?.odPolicyStartDate) : null
  );
  const OdPolicyStDateFunction = (e) => {
    setOdPolicyStartDate(e.$d);
    setTpPolicyStartDate(e.$d);
    formRef.setFieldValue("odPolicyStartDate", e.$d);
    formRef.setFieldValue("tpPolicyStartDate", e.$d);
  };

  const OdPolicyPeriodFunction = (event) => {
    formRef.setFieldValue("odPolicyPeriod", event.target.value);
    const odPolicyEndDate = moment(odPolicyStartDate)
      .add(event.target.value, "Y")
      .subtract(1, "days");
    formRef.setFieldValue("odPolicyEndDate", odPolicyEndDate?._d);
    setOdPolicyEndDateValue(odPolicyEndDate);
  };

  const [tpPolicyStartDate, setTpPolicyStartDate] = useState(
    formType === "edit" ? dayjs(selectedData?.tpPolicyStartDate) : null
  );

  const TPPolicyStDateFunction = (e) => {
    setTpPolicyStartDate(e.$d);
    formRef.setFieldValue("tpPolicyStartDate", e.$d);
  };

  const TpPolicyPeriodFunction = (event) => {
    formRef.setFieldValue("tpPolicyPeriod", event.target.value);
    const tpPolicyEndDate = moment(tpPolicyStartDate)
      .add(event.target.value, "Y")
      .subtract(1, "days");
    formRef.setFieldValue("tpPolicyEndDate", tpPolicyEndDate?._d);
    settpPolicyDate(tpPolicyEndDate);
  };

  const EditableFunction = () => {
    setEditableData(false);
    setOpenViewCal(false);
  };

  const CalaculteFunction = (e) => {
    const UserODAmountValue = (e?.odPremium * e.userOdPercentage) / 100;
    const UserTPAmountValue = (e?.tpPremium * e.userTpPercentage) / 100;
    const UserNETAmountValue = (e?.netPremium * e.userNetPercentage) / 100;
    const BranchODAmountValue = (e?.odPremium * e.branchOdPercentage) / 100;
    const BranchTPAmountValue = (e?.tpPremium * e.branchTpPercentage) / 100;
    const BranchNETAmountValue = (e?.netPremium * e.branchNetPercentage) / 100;
    const ReceivableODAmountValue =
      (e?.odPremium * e.receivableOdPercentage) / 100;
    const ReceivableTPAmountValue =
      (e?.tpPremium * e.receivableTpPercentage) / 100;
    const ReceivableNetAmountValue =
      (e?.netPremium * e.receivableNetPercentage) / 100;
    const UserTotalValue = (
      (UserODAmountValue ? UserODAmountValue : 0) +
      (UserTPAmountValue ? UserTPAmountValue : 0) +
      (UserNETAmountValue ? UserNETAmountValue : 0)
    ).toFixed(2);
    const BranchTotalValue = (
      (BranchODAmountValue ? BranchODAmountValue : 0) +
      (BranchTPAmountValue ? BranchTPAmountValue : 0) +
      (BranchNETAmountValue ? BranchNETAmountValue : 0)
    ).toFixed(2);
    const ReceivableTotalValue = (
      (ReceivableODAmountValue ? ReceivableODAmountValue : 0) +
      (ReceivableTPAmountValue ? ReceivableTPAmountValue : 0) +
      (ReceivableNetAmountValue ? ReceivableNetAmountValue : 0)
    ).toFixed(2);
    formRef.setFieldValue(
      "userOdAmount",
      UserODAmountValue ? UserODAmountValue : 0
    );
    formRef.setFieldValue(
      "userTpAmount",
      UserTPAmountValue ? UserTPAmountValue : 0
    );
    formRef.setFieldValue(
      "userNetAmount",
      UserNETAmountValue ? UserNETAmountValue : 0
    );
    formRef.setFieldValue(
      "branchOdAmount",
      BranchODAmountValue ? BranchODAmountValue : 0
    );
    formRef.setFieldValue(
      "branchTpAmount",
      BranchTPAmountValue ? BranchTPAmountValue : 0
    );
    formRef.setFieldValue(
      "branchNetAmount",
      BranchNETAmountValue ? BranchNETAmountValue : 0
    );
    formRef.setFieldValue(
      "receivableOdAmount",
      ReceivableODAmountValue ? ReceivableODAmountValue : 0
    );
    formRef.setFieldValue(
      "receivableTpAmount",
      ReceivableTPAmountValue ? ReceivableTPAmountValue : 0
    );
    formRef.setFieldValue(
      "receivableNetAmount",
      ReceivableNetAmountValue ? ReceivableNetAmountValue : 0
    );
    formRef.setFieldValue("userTotalPayable", UserTotalValue);
    formRef.setFieldValue("branchTotalPayabl", BranchTotalValue);
    formRef.setFieldValue("receivableTotalPayabl", ReceivableTotalValue);
  };
  // const { errors, touched } = useFormikContext();

  const ErrorHandling = async (errors) => {
    const errorKeys = Object.keys(errors);
    if (errorKeys.length > 0) {
      const firstError = errors[errorKeys[0]];
      await ToastError(firstError);
    }
  };
  return (
    <>
      <div className={Styles.MainRenderinContainer}>
        {/* <Grid container className="DrawerHeader">
          <Grid item xs={6} sm={6}>
            <Typography>
              {formType === "view" ? "View Policy List" : "Edit Policy List"}
            </Typography>
          </Grid>
          <Grid item xs={6} sm={6} className="d-flex justify-content-end">
            <CloseIcon
              onClick={() => setOpenEditPolicyDrawer(false)}
              sx={{ cursor: "pointer" }}
            />
          </Grid>
        </Grid> */}
        <Stack direction={"row"} alignItems={"center"}>
          <div className="breadcrumb" style={{ marginLeft: "33px" }}>
            <a
              className="text-color"
              onClick={() => {
                navigate("/dashboard");
              }}
              style={{ cursor: "pointer" }}
            >
              {"Home"}
            </a>
            <span
              style={{
                padding: "0px 10px 0px 10px",
              }}
            >
              <ArrowForwardIosIcon
                style={{
                  fontSize: "13px",
                }}
              />
            </span>
            <a
              className="text-color"
              onClick={() => {
                setOpenEditPolicyDrawer(false);
              }}
              style={{ cursor: "pointer" }}
            >
              {"Policy List"}
            </a>
            <span
              style={{
                padding: "0px 10px 0px 10px",
              }}
            >
              <ArrowForwardIosIcon
                style={{
                  fontSize: "13px",
                }}
              />
            </span>
            <a className="text-color">{"Edit Policy List"}</a>
            <span
              style={{
                padding: "0px 10px 0px 10px",
              }}
            >
              <ArrowForwardIosIcon
                style={{
                  fontSize: "13px",
                }}
              />
            </span>
          </div>
        </Stack>

        {formType === "view" ? (
          <div className={Styles.formContainer}>
            <Grid
              container
              className="Master_Card_Container"
              sx={{ border: "none" }}
            >
              <Grid
                container
                alignItems={"center"}
                className="Master_Card_Sub_Container"
              >
                <Grid item xs={12} sm={6} md={6}>
                  <Typography className="Master_Card_Tittle">
                    {/* {source == "Profile" ? source : "Add User"} */}
                    View Policy List
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={6}
                  className="d-flex justify-content-end"
                >
                  <CloseIcon
                    onClick={() => setOpenEditPolicyDrawer(false)}
                    sx={{ cursor: "pointer" }}
                  />
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Divider
                  sx={{
                    backgroundColor: "#EAECF0",
                    borderWidth: 1,
                  }}
                />
              </Grid>
            </Grid>
            <Box className={Styles.formContent}>
              <Box
                sx={{
                  borderBottom: "1px solid #EAECF0",
                  padding: "0 15px",
                  paddingBottom: "20px",
                }}
              >
                <Typography mt={3} className={Styles.formTitleHead}>
                  Policy Files
                </Typography>

                <Stack direction={"row"}>
                  <Grid container spacing={2} mt={1}>
                    <Grid item xs={12} sm={2}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        Create Policy
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        {selectedData?.createdBy}
                        <br />
                        {selectedData?.createdAt
                          ? moment(selectedData?.createdAt).format(
                              "DD/MM/YYYY hh:mm:ss A"
                            )
                          : ""}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={2}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        Entry Pending
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        {selectedData?.verifyPendingBy || "--"}
                        <br />
                        {selectedData?.verifyPendingAt
                          ? moment(selectedData?.verifyPendingAt).format(
                              "DD/MM/YYYY hh:mm:ss A"
                            )
                          : ""}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={2}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        Approved
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        {selectedData?.approveBy || "--"}
                        <br />
                        {selectedData?.userPayable?.updatedAt
                          ? moment(selectedData?.userPayable?.updatedAt).format(
                              "DD/MM/YYYY hh:mm:ss A"
                            )
                          : ""}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={2}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        CC Entry
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        {selectedData?.ticketCreatedBy || "--"}
                        <br />
                        {selectedData?.ticketCreatedDate
                          ? moment(selectedData?.ticketCreatedDate).format(
                              "DD/MM/YYYY hh:mm:ss A"
                            )
                          : ""}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={2}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        View PDF
                      </Typography>
                      <Typography
                        className={Styles.inputValue}
                        sx={{ cursor: "pointer" }}
                        onClick={() => ViewPdfFunction()}
                      >
                        <PictureAsPdfIcon />
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={2}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1, cursor: "pointer" }}
                      >
                        Other Documents
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        <DescriptionSharpIcon />
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={2}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        User Name
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        {selectedData?.userId?.name || "--"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={2}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        Branch
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        {/* {selectedData?.userId?.name} */}--
                      </Typography>
                    </Grid>
                  </Grid>
                </Stack>
              </Box>
              <Box
                sx={{
                  borderBottom: "1px solid #EAECF0",
                  padding: "0 15px",
                  paddingBottom: "20px",
                }}
              >
                <Typography mt={3} className={Styles.formTitleHead}>
                  Policy Details
                </Typography>

                <Stack direction={"row"}>
                  <Grid container spacing={2} mt={1}>
                    <Grid item xs={12} sm={3.5}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        Issue Date
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        {moment(selectedData?.issueDate).format("L")}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={0.7} />
                    <Grid item xs={12} sm={3.6}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        Company Name
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        {selectedData?.companyId?.companyName || "--"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={0.7} />
                    <Grid item xs={12} sm={3.5}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        Product
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        {selectedData?.productId?.product || "--"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={3.5}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        Sub Product
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        {selectedData?.subProductId?.subProduct || "--"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={0.7} />
                    <Grid item xs={12} sm={3.6}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        Booking Code
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        {selectedData?.bookingCodeId?.bookingCode || "--"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={0.7} />
                    <Grid item xs={12} sm={3.5}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        Sub Booking Code
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        {selectedData?.subBookingCodeId?.subBookingCode || "--"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={3.5}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        Policy Type
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        {selectedData?.policyTypeId?.policyType || "--"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={0.7} />
                    <Grid item xs={12} sm={3.6}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        Policy Number
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        {selectedData?.policyNumber || "--"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={0.7} />
                    <Grid item xs={12} sm={3.5}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        LoginId
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        {selectedData?.loginIdFull || "--"}
                      </Typography>
                    </Grid>
                  </Grid>
                </Stack>
              </Box>
              <Box
                sx={{
                  borderBottom: "1px solid #EAECF0",
                  padding: "0 15px",
                  paddingBottom: "20px",
                }}
              >
                <Typography mt={3} className={Styles.formTitleHead}>
                  Customer Details
                </Typography>

                <Stack direction={"row"}>
                  <Grid container spacing={2} mt={1}>
                    <Grid item xs={12} sm={3.5}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        Customer Name
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        {selectedData?.customerName || "--"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={0.7} />
                    <Grid item xs={12} sm={3.6}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        Mobile
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        {selectedData?.mobileNumber || "--"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={0.7} />
                    <Grid item xs={12} sm={3.5}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        Email{" "}
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        {selectedData?.email || "--"}
                      </Typography>
                    </Grid>
                  </Grid>
                </Stack>
              </Box>
              <Box
                sx={{
                  borderBottom: "1px solid #EAECF0",
                  padding: "0 15px",
                  paddingBottom: "20px",
                }}
              >
                <Typography mt={3} className={Styles.formTitleHead}>
                  Vehicle Details
                </Typography>

                <Stack direction={"row"}>
                  <Grid container spacing={2} mt={1}>
                    <Grid item xs={12} sm={3.5}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        Reg Number
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        {selectedData?.registrationNumber || "--"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={0.7} />
                    <Grid item xs={12} sm={3.6}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        Make
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        {selectedData?.make?.vehicleMake || "--"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={0.7} />
                    <Grid item xs={12} sm={3.5}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        Model
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        {selectedData?.model || "--"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={3.5}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        CC
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        {selectedData?.cc || "--"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={0.7} />
                    <Grid item xs={12} sm={3.6}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        Seating Capacity
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        {selectedData?.seatingCapacity || "--"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={0.7} />
                    <Grid item xs={12} sm={3.5}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        GVW
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        {selectedData?.gvw || "--"}
                      </Typography>
                    </Grid>
                  </Grid>
                </Stack>
              </Box>
              <Box
                sx={{
                  borderBottom: "1px solid #EAECF0",
                  padding: "0 15px",
                  paddingBottom: "20px",
                }}
              >
                <Typography mt={3} className={Styles.formTitleHead}>
                  OD Policy Date
                </Typography>

                <Stack direction={"row"}>
                  <Grid container spacing={2} mt={1}>
                    <Grid item xs={12} sm={3.5}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        OD Policy Start Date
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        {moment(selectedData?.odPolicyStartDate).format("L")}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={0.7} />
                    <Grid item xs={12} sm={3.6}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        OD Policy Period
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        {selectedData?.odPolicyPeriod || "--"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={0.7} />
                    <Grid item xs={12} sm={3.5}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        OD Policy End Date
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        {moment(selectedData?.odPolicyEndDate).format("L")}
                      </Typography>
                    </Grid>
                  </Grid>
                </Stack>
              </Box>
              <Box
                sx={{
                  borderBottom: "1px solid #EAECF0",
                  padding: "0 15px",
                  paddingBottom: "20px",
                }}
              >
                <Typography mt={3} className={Styles.formTitleHead}>
                  TP Policy Date
                </Typography>

                <Stack direction={"row"}>
                  <Grid container spacing={2} mt={1}>
                    <Grid item xs={12} sm={3.5}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        TP Policy Start Date
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        {moment(selectedData?.tpPolicyStartDate).format("L")}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={0.7} />
                    <Grid item xs={12} sm={3.6}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        TP Policy Period
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        {selectedData?.tpPolicyPeriod || "--"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={0.7} />
                    <Grid item xs={12} sm={3.5}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        TP Policy End Date
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        {moment(selectedData?.tpPolicyEndDate).format("L")}
                      </Typography>
                    </Grid>
                  </Grid>
                </Stack>
              </Box>
              <Box
                sx={{
                  borderBottom: "1px solid #EAECF0",
                  padding: "0 15px",
                  paddingBottom: "20px",
                }}
              >
                <Typography mt={3} className={Styles.formTitleHead}>
                  Premium
                </Typography>

                <Stack direction={"row"}>
                  <Grid container spacing={2} mt={1}>
                    <Grid item xs={12} sm={3.5}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        OD Disc
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        {selectedData?.odDisc || "--"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={0.7} />
                    <Grid item xs={12} sm={3.6}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        OD Premium
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        {selectedData?.odPremium || "--"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={0.7} />
                    <Grid item xs={12} sm={3.5}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        TP Premium
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        {selectedData?.tpPremium || "--"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={3.5}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        NET Premium
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        {selectedData?.netPremium || "--"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={0.7} />
                    <Grid item xs={12} sm={3.6}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        Total Premium
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        {selectedData?.totalPremium || "--"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={0.7} />
                    <Grid item xs={12} sm={3.5}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        PA Cover
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        {selectedData?.paCover || "--"}
                      </Typography>
                    </Grid>
                  </Grid>
                </Stack>
              </Box>
              <Box
                sx={{
                  borderBottom: "1px solid #EAECF0",
                  padding: "0 15px",
                  paddingBottom: "20px",
                }}
              >
                <Typography mt={3} className={Styles.formTitleHead}>
                  Payment Details
                </Typography>

                <Stack direction={"row"}>
                  <Grid container spacing={2} mt={1}>
                    <Grid item xs={12} sm={3.5}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        Payment Mode
                      </Typography>
                      <Typography className={Styles.inputValue}>
                        {selectedData?.paymentMode || "--"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={0.7} />
                  </Grid>
                </Stack>
              </Box>
            </Box>
          </div>
        ) : (
          <div className={Styles.formContainer}>
            <Grid
              container
              className="Master_Card_Container"
              sx={{ border: "none" }}
            >
              <Grid item xs={12}>
                <Formik
                  initialValues={initialValues}
                  onSubmit={(values) => {
                    onSubmit(values);
                  }}
                  innerRef={(ref) => {
                    if (ref) {
                      if (value === 1) {
                        setDisableOne(
                          ref?.errors?.bookingCodeId?.length ||
                            ref?.errors?.policyTypeId?.length ||
                            ref?.errors?.productId?.length ||
                            ref?.errors?.companyId?.length ||
                            ref?.errors?.subBookingCodeId?.length ||
                            ref?.errors?.subProductId?.length
                            ? true
                            : false
                        );
                      } else if (value === 2) {
                        setDisableOne(
                          ref?.errors?.customerName?.length ||
                            ref?.errors?.mobileNumber?.length ||
                            ref?.errors?.email?.length
                        );
                      } else if (value === 3) {
                        setDisableOne(
                          ref?.errors?.registrationNumber?.length ||
                            ref?.errors?.make?.length ||
                            ref?.errors?.model?.length ||
                            ref?.errors?.cc?.length ||
                            ref?.errors?.gvw?.length ||
                            ref?.errors?.seatingCapacity?.length ||
                            ref?.errors?.registrationYear?.length ||
                            ref?.errors?.fuelType?.length
                        );
                      } else if (value === 4) {
                        setDisableOne(
                          ref?.errors?.odPolicyStartDate?.length ||
                            ref?.errors?.odPolicyPeriod?.length ||
                            ref?.errors?.odPolicyEndDate?.length ||
                            ref?.errors?.tpPolicyEndDate?.length ||
                            ref?.errors?.odPolicyPeriod?.length ||
                            ref?.errors?.tpPolicyPeriod?.length
                        );
                      } else if (value === 5) {
                        setDisableOne(
                          ref?.errors?.odDisc?.length ||
                            ref?.errors?.odPremium?.length ||
                            ref?.errors?.tpPremium?.length ||
                            ref?.errors?.netPremium?.length ||
                            ref?.errors?.totalPremium?.length ||
                            ref?.errors?.paCover?.length
                        );
                      }
                      formRef = ref;
                    }
                  }}
                  validationSchema={
                    editType === "CommonEdit" ? null : validationSchema
                  }
                >
                  {({ values, setFieldValue, errors }) => (
                    <Form className={Styles.formContent} sx={{ width: "100%" }}>
                      <Grid
                        container
                        alignItems={"center"}
                        className="Master_Card_Sub_Container"
                      >
                        <Grid item xs={12} sm={6} md={6}>
                          <Typography className="Master_Card_Tittle">
                            {/* {source == "Profile" ? source : "Add User"} */}
                            Edit Policy List
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sm={6}
                          md={6}
                          className="d-flex justify-content-end"
                        >
                          {selectedData.status ===
                          PolicyFilterTypes[2].value ? (
                            <Grid
                              item
                              xs={12}
                              sm={2}
                              sx={{
                                display: editableData ? "flex" : "none",
                                justifyContent: "end",
                                marginRight: "15px",
                              }}
                            >
                              <Button
                                variant="outlined"
                                className="w-100 Master_Card_Filter_Button"
                                size="large"
                                onClick={() => EditableFunction()}
                              >
                                Edit Policy
                              </Button>
                            </Grid>
                          ) : null}
                          <Grid item xs={12} sm={2}>
                            <button
                              className="w-100 Master_Card_create_Button"
                              // type="submit"
                              style={{ border: "none" }}
                              onClick={() => ErrorHandling(errors)}
                            >
                              {editableData ? "Verify Policy" : "Update"}
                            </button>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item xs={12}>
                        <Divider
                          sx={{
                            backgroundColor: "#EAECF0",
                            borderWidth: 1,
                          }}
                        />
                      </Grid>
                      <Box
                        sx={{
                          borderBottom: "1px solid #EAECF0",
                          padding: "0 15px",
                          paddingBottom: "20px",
                        }}
                      >
                        <Typography mt={3} className={Styles.formTitleHead}>
                          Policy Files
                        </Typography>

                        <Stack direction={"row"}>
                          <Grid container spacing={2} mt={1}>
                            <Grid item xs={12} sm={2}>
                              <Typography
                                className={Styles.inputTitle}
                                sx={{ fontSize: "12px", mb: 1 }}
                              >
                                Create Policy
                              </Typography>
                              <Typography className={Styles.inputValue}>
                                {selectedData?.createdBy}
                                <br />
                                {selectedData?.createdAt
                                  ? moment(selectedData?.createdAt).format(
                                      "DD/MM/YYYY hh:mm:ss A"
                                    )
                                  : ""}
                              </Typography>
                            </Grid>
                            <Grid item xs={12} sm={2}>
                              <Typography
                                className={Styles.inputTitle}
                                sx={{ fontSize: "12px", mb: 1 }}
                              >
                                Entry Pending
                              </Typography>
                              <Typography className={Styles.inputValue}>
                                {selectedData?.verifyPendingBy || "--"}
                                <br />
                                {selectedData?.verifyPendingAt
                                  ? moment(
                                      selectedData?.verifyPendingAt
                                    ).format("DD/MM/YYYY hh:mm:ss A")
                                  : ""}
                              </Typography>
                            </Grid>
                            <Grid item xs={12} sm={2}>
                              <Typography
                                className={Styles.inputTitle}
                                sx={{ fontSize: "12px", mb: 1 }}
                              >
                                Approved
                              </Typography>
                              <Typography className={Styles.inputValue}>
                                {selectedData?.approveBy || "--"}
                                <br />
                                {selectedData?.userPayable?.updatedAt
                                  ? moment(
                                      selectedData?.userPayable?.updatedAt
                                    ).format("DD/MM/YYYY hh:mm:ss A")
                                  : ""}
                              </Typography>
                            </Grid>
                            <Grid item xs={12} sm={2}>
                              <Typography
                                className={Styles.inputTitle}
                                sx={{ fontSize: "12px", mb: 1 }}
                              >
                                CC Entry
                              </Typography>
                              <Typography className={Styles.inputValue}>
                                {selectedData?.ticketCreatedBy || "--"}
                                <br />
                                {selectedData?.ticketCreatedDate
                                  ? moment(
                                      selectedData?.ticketCreatedDate
                                    ).format("DD/MM/YYYY hh:mm:ss A")
                                  : ""}
                              </Typography>
                            </Grid>
                            <Grid item xs={12} sm={2}>
                              <Typography
                                className={Styles.inputTitle}
                                sx={{ fontSize: "12px", mb: 1 }}
                              >
                                View PDF
                              </Typography>
                              <Typography
                                className={Styles.inputValue}
                                sx={{ cursor: "pointer" }}
                                onClick={() => ViewPdfFunction()}
                              >
                                <RemoveRedEyeIcon />
                              </Typography>
                            </Grid>
                            <Grid
                              item
                              xs={12}
                              sm={2}
                              sx={{ display: approveKey ? "block" : "none" }}
                            >
                              <Typography
                                className={Styles.inputTitle}
                                sx={{
                                  fontSize: "12px",
                                  mb: 1,
                                  cursor: "pointer",
                                }}
                              >
                                Auto Fill
                              </Typography>
                              <Typography
                                className={Styles.inputValue}
                                onClick={() => AutoFillFunction()}
                              >
                                <DescriptionSharpIcon />
                              </Typography>
                            </Grid>
                            <Grid
                              item
                              xs={12}
                              sm={2}
                              sx={{
                                display:
                                  selectedData?.status ===
                                  PolicyFilterTypes[1].value
                                    ? "none"
                                    : "block",
                              }}
                            >
                              <Typography
                                className={Styles.inputTitle}
                                sx={{
                                  fontSize: "12px",
                                  mb: 1,
                                  cursor: "pointer",
                                }}
                              >
                                Other Documents
                              </Typography>
                              <Typography
                                className={Styles.inputValue}
                                sx={{
                                  display:
                                    selectedData?.status ===
                                    PolicyFilterTypes[1].value
                                      ? "none"
                                      : "block",
                                }}
                              >
                                <DescriptionSharpIcon />
                              </Typography>
                            </Grid>
                            {showPolUpTable ||
                            selectedData.status ===
                              PolicyFilterTypes[2].value ? null : (
                              <>
                                <Grid
                                  item
                                  xs={12}
                                  sm={3}
                                  sx={{
                                    display:
                                      !PolicyFilterTypes[1].value ||
                                      editType === "CommonEdit"
                                        ? "none"
                                        : "block",
                                  }}
                                >
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    Policy Number
                                  </Typography>
                                  <Field
                                    className="textField w-100"
                                    placeHolder="Enter Policy Number"
                                    name="checkedNumber"
                                  />
                                </Grid>
                                <Grid item xs={12} sm={1} />
                                <Grid
                                  item
                                  xs={12}
                                  sm={3}
                                  sx={{
                                    display:
                                      !(
                                        selectedData?.status ===
                                        PolicyFilterTypes[1].value
                                      ) || editType === "CommonEdit"
                                        ? "none"
                                        : "block",
                                  }}
                                >
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  ></Typography>
                                  <Button
                                    className="Common_Button"
                                    sx={{ marginTop: "18px" }}
                                    onClick={() => policyNumberChecking(values)}
                                  >
                                    Check
                                  </Button>
                                </Grid>
                              </>
                            )}
                          </Grid>
                        </Stack>
                      </Box>

                      <Box
                        sx={{
                          borderBottom: "1px solid #EAECF0",
                          padding: "0 15px",
                          display: showRejectField ? "flex" : "none",
                        }}
                      >
                        <Typography mt={3} className={Styles.formTitleHead}>
                          Rejected
                        </Typography>

                        <Stack direction={"row"}>
                          <Grid container spacing={2} mt={1}>
                            <Grid item xs={12} sm={3.5} sx={{ mb: 2 }}>
                              <Typography
                                className={Styles.inputTitle}
                                sx={{ fontSize: "12px", mb: 1 }}
                              >
                                Reason
                              </Typography>
                              <Autocomplete
                                className="AutoComplete_InputBox"
                                options={[
                                  {
                                    label: "Policy Number Mismatching",
                                    id: 1,
                                  },
                                  { label: "Other Agent Policy", id: 2 },
                                ]}
                                onChange={(e, v) =>
                                  setFieldValue("rejectedReason", v.label)
                                }
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    placeholder="Select Reason"
                                  />
                                )}
                              ></Autocomplete>
                            </Grid>
                            <Grid item xs={12} sm={0.7}></Grid>
                            <Grid item xs={12} sm={3} sx={{ mb: 1 }}>
                              <Button
                                onClick={() => RejectedFunction(values)}
                                className={Styles.Reject_Button}
                              >
                                Reject
                              </Button>
                            </Grid>
                          </Grid>
                        </Stack>
                      </Box>
                      {showPolUpTable ? (
                        <Box sx={{ width: "100%", typography: "body1" }}>
                          <TabContext value={value}>
                            <Box
                              sx={{
                                // borderBottom: 1,
                                // borderColor: "divider",
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              <Tabs
                                value={value}
                                onChange={handleChange}
                                aria-label="stepper tabs"
                                sx={{
                                  borderBottom: "none",
                                  ".MuiTabs-indicator": { display: "none" }, // Hide the bottom indicator line
                                  backgroundColor: "none",
                                }}
                              >
                                <Tab
                                  label={
                                    <span
                                      className={`${Styles.tab} ${
                                        value === 1 ? Styles.active : ""
                                      }`}
                                    >
                                      <span className={Styles.circle}>1</span>{" "}
                                      Policy Details
                                    </span>
                                  }
                                  value={1}
                                />
                                <div className={Styles.dashedLine}>
                                  - - - - - -
                                </div>
                                <Tab
                                  label={
                                    <span
                                      className={`${Styles.tab} ${
                                        value === 2 ? Styles.active : ""
                                      }`}
                                    >
                                      <span className={Styles.circle}>2</span>{" "}
                                      Customer Details
                                    </span>
                                  }
                                  value={2}
                                />
                                <div className={Styles.dashedLine}>
                                  - - - - - -
                                </div>
                                <Tab
                                  label={
                                    <span
                                      className={`${Styles.tab} ${
                                        value === 3 ? Styles.active : ""
                                      }`}
                                    >
                                      <span className={Styles.circle}>3</span>{" "}
                                      Vehicle Details
                                    </span>
                                  }
                                  value={3}
                                />
                                <div className={Styles.dashedLine}>
                                  - - - - - -
                                </div>{" "}
                                <Tab
                                  label={
                                    <span
                                      className={`${Styles.tab} ${
                                        value === 4 ? Styles.active : ""
                                      }`}
                                    >
                                      <span className={Styles.circle}>4</span>{" "}
                                      Policy Date
                                    </span>
                                  }
                                  value={4}
                                />
                                <div className={Styles.dashedLine}>
                                  - - - - - -
                                </div>{" "}
                                <Tab
                                  label={
                                    <span
                                      className={`${Styles.tab} ${
                                        value === 5 ? Styles.active : ""
                                      }`}
                                    >
                                      <span className={Styles.circle}>5</span>{" "}
                                      Premium
                                    </span>
                                  }
                                  value={5}
                                />
                              </Tabs>
                            </Box>
                            <TabPanel value={1}>
                              <Grid container spacing={2} mt={1}>
                                <Grid item xs={12} sm={3.5}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    User Name
                                  </Typography>
                                  <Autocomplete
                                    className="AutoComplete_InputBox"
                                    name="userId"
                                    options={userDetails}
                                    value={userValue}
                                    onInputChange={(e, v) => setUserValue(v)}
                                    onChange={(e, v) => {
                                      setFieldValue("userId", v?._id);
                                      setSelectedUserId(v?._id);
                                      setUserValue(v?.label);
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        placeholder="Select User"
                                      />
                                    )}
                                    isOptionEqualToValue={(option, value) =>
                                      option?.label === value
                                    }
                                    renderOption={(props, option) => (
                                      <li {...props} key={option._id}>
                                        {option.name}
                                      </li>
                                    )}
                                  />
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.6}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    Login ID
                                  </Typography>
                                  <Autocomplete
                                    name="loginIdFull"
                                    disablePortal
                                    className="AutoComplete_InputBox"
                                    id="combo-box-demo"
                                    value={selectedLoginPortal}
                                    options={loginPortalDetails}
                                    onChange={(e, v) => {
                                      setSelectedLoginPortal(v?.loginPortal);
                                      // setFieldValue("loginId.companyId", v?.companyId)
                                      // setFieldValue("loginId.userId", v?.userId)
                                      setFieldValue(
                                        "loginIdFull",
                                        v?.loginPortal
                                      );
                                    }}
                                    renderOption={(props, option) => (
                                      <li {...props} key={option._id}>
                                        {option.loginPortal}
                                      </li>
                                    )}
                                    getOptionLabel={(option) => {
                                      // console.log("option  ", option);
                                      return typeof option === "object" &&
                                        option !== null
                                        ? option.loginPortal || "Unknown"
                                        : option;
                                    }}
                                    isOptionEqualToValue={(e, v) =>
                                      e.loginPortal === v
                                    }
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        placeholder="Select Login ID"
                                      />
                                    )}
                                  />
                                </Grid>

                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.5}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    Policy Number
                                  </Typography>
                                  <Field
                                    name="policyNumber"
                                    placeHolder="Enter Policy Number"
                                    className="textField w-100"
                                  />
                                </Grid>
                                <Grid item xs={12} sm={3.5} sx={{ mb: 1 }}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    Issue Date
                                  </Typography>
                                  <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                  >
                                    <DatePicker
                                      format="DD/MM/YYYY"
                                      name="issueDate"
                                      className="Date_Picker w-100"
                                      value={fillIssueDate}
                                      onChange={(e) =>
                                        setFieldValue("issueDate", e.$d)
                                      }
                                    />
                                  </LocalizationProvider>
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.6} sx={{ mb: 1 }}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    Company
                                  </Typography>
                                  <Autocomplete
                                    className="AutoComplete_InputBox"
                                    name="companyId"
                                    options={companyDetails}
                                    value={selectedCompany}
                                    onChange={(e, v) => {
                                      setFieldValue("companyId", v?._id);
                                      setSelectedCompanyId(v?._id);
                                      setCompanyValue(v?.label);
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        placeholder="Select Company"
                                      />
                                    )}
                                    isOptionEqualToValue={(option, value) =>
                                      option?.label === value
                                    }
                                    renderOption={(props, option) => (
                                      <li {...props} key={option._id}>
                                        {option.shortName}
                                      </li>
                                    )}
                                  />
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.5} sx={{ mb: 1 }}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    Policy Type
                                  </Typography>
                                  <Autocomplete
                                    className="AutoComplete_InputBox"
                                    name="policyTypeId"
                                    options={policyTypeDetails}
                                    value={policyTypeValue}
                                    onInputChange={(e, v) =>
                                      setPolicyTypeValue(v)
                                    }
                                    onChange={(e, v) => {
                                      setFieldValue("policyTypeId", v?._id);
                                      setPolicyTypeValue(v?.label);
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        placeholder="Select Policy Type"
                                      />
                                    )}
                                    isOptionEqualToValue={(option, value) =>
                                      option.policyType === value
                                    }
                                  />
                                </Grid>

                                <Grid item xs={12} sm={3.5} sx={{ mb: 1 }}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    Product
                                  </Typography>
                                  <Autocomplete
                                    className="AutoComplete_InputBox"
                                    name="productId"
                                    options={productDetails}
                                    value={productValue}
                                    onInputChange={(e, v) => setProductValue(v)}
                                    onChange={(e, v) => {
                                      setFieldValue("productId", v?._id);
                                      setProductIdValue(v?._id);
                                      setProductValue(v?.label);
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        placeholder="Select Product"
                                      />
                                    )}
                                    isOptionEqualToValue={(option, value) =>
                                      option.product === value
                                    }
                                  />
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.6} sx={{ mb: 1 }}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    Sub Product
                                  </Typography>
                                  <Autocomplete
                                    className="AutoComplete_InputBox"
                                    name="subProductId"
                                    options={subProductDetails}
                                    value={subProductValue}
                                    onInputChange={(e, v) =>
                                      setSubProductValue(v)
                                    }
                                    onChange={(e, v) => {
                                      setFieldValue("subProductId", v?._id);
                                      setSubProductIdValue(v?._id);
                                      setSubProductValue(v?.label);
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        placeholder="Select Sub Product"
                                      />
                                    )}
                                    isOptionEqualToValue={(option, value) =>
                                      option.subProduct === value
                                    }
                                  />
                                </Grid>
                                <Grid item xs={12} sm={3.5} />
                                <Grid item xs={12} sm={3.5} sx={{ mb: 1 }}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    Booking Code
                                  </Typography>
                                  <Autocomplete
                                    className="AutoComplete_InputBox"
                                    name="bookingCodeId"
                                    options={bookingCodeDetails}
                                    value={bookingCodeValue}
                                    onInputChange={(e, v) =>
                                      setBookingCodeValue(v)
                                    }
                                    onChange={(e, v) => {
                                      setFieldValue(
                                        "bookingCodeId",
                                        v?.bookingCodeId._id
                                      );
                                      setBookingCodeValue(v?.label);
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        placeholder="Select Booking Code"
                                      />
                                    )}
                                    isOptionEqualToValue={(option, value) =>
                                      option.bookingCode === value
                                    }
                                  />
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.6} sx={{ mb: 1 }}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    Sub Booking Code
                                  </Typography>
                                  <Autocomplete
                                    className="AutoComplete_InputBox"
                                    name="subBookingCodeId"
                                    options={subBookingCodeDetails}
                                    value={subBookingCodeValue}
                                    onInputChange={(e, v) =>
                                      setSubBookingCodeValue(v)
                                    }
                                    onChange={(e, v) => {
                                      setFieldValue("subBookingCodeId", v?._id);
                                      setSubBookingCodeValue(v?.label);
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        placeholder="Select Sub Booking"
                                      />
                                    )}
                                    isOptionEqualToValue={(option, value) =>
                                      option.subBookingCode === value
                                    }
                                  />
                                </Grid>
                              </Grid>
                            </TabPanel>
                            <TabPanel value={2}>
                              <Grid container spacing={2} mt={1}>
                                <Grid item xs={12} sm={3.5}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    Customer Name
                                  </Typography>
                                  <Field
                                    className="textField w-100"
                                    name="customerName"
                                    placeHolder="Enter Customer Name"
                                  />
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.6}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    Mobile Number
                                  </Typography>
                                  <Field
                                    className="textField w-100"
                                    name="mobileNumber"
                                    placeHolder="Enter Mobile Number"
                                  />
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.5}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    Email
                                  </Typography>
                                  <Field
                                    className="textField w-100"
                                    name="email"
                                    placeHolder="Enter Email"
                                  />
                                </Grid>
                              </Grid>
                            </TabPanel>
                            <TabPanel value={3}>
                              <Grid container spacing={2} mt={1}>
                                <Grid item xs={12} sm={1.75}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    Registration Number
                                  </Typography>
                                  <Field
                                    className="textField w-100"
                                    name="registrationNumber"
                                    placeHolder="Enter Registration Number"
                                    onBlur={
                                      (e) => checkRTO(rtoList, e.target.value) // Changes by Arun
                                    }
                                  />
                                </Grid>
                                {/* Changes by Arun */}
                                <Grid item xs={12} sm={1.75}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    RTO
                                  </Typography>
                                  <Autocomplete
                                    className="AutoComplete_InputBox"
                                    name="rtoId"
                                    options={rtoListDropdown}
                                    value={rtoValue}
                                    onChange={(e, v) => {
                                      setFieldValue("rtoId", v?._id);
                                      setRtoValue(v?.label);
                                    }}
                                    // changes by somesh
                                    renderOption={(props, option) => (
                                      <li {...props} key={option._id}>
                                        {option.label}
                                      </li>
                                    )}
                                    clearIcon={true}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        placeholder="Select RTO"
                                      />
                                    )}
                                    disabled={editableData ? true : false}
                                  />
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.6} sx={{ mb: 1 }}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    Make{" "}
                                  </Typography>
                                  <Autocomplete
                                    className="AutoComplete_InputBox"
                                    name="make"
                                    options={vehicleMakeDetails}
                                    value={vehicleValue}
                                    onChange={(e, v) => {
                                      setFieldValue("make", v?._id);
                                      setVehicleValue(v?.label);
                                    }}
                                    clearIcon={false}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        placeholder="Select Make"
                                      />
                                    )}
                                    isOptionalEqualToValue={(option, value) =>
                                      option.vehicleMake === value
                                    }
                                    disabled={editableData ? true : false}
                                  />
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.5} sx={{ mb: 1 }}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    Model
                                  </Typography>
                                  <Field
                                    className="textField w-100"
                                    name="model"
                                    placeHolder="Enter Model"
                                  />
                                </Grid>
                                <Grid item xs={12} sm={3.5} sx={{ mb: 1 }}>
                                  <Grid container spacing={1}>
                                    <Grid item sx={{ width: "30%" }}>
                                      <Typography
                                        className={Styles.inputTitle}
                                        sx={{ fontSize: "12px", mb: 1 }}
                                      >
                                        CC
                                      </Typography>
                                      <Field
                                        className="textField w-100"
                                        name="cc"
                                        placeHolder="Enter CC"
                                      />
                                    </Grid>
                                    <Grid item sx={{ width: "30%" }}>
                                      <Typography
                                        className={Styles.inputTitle}
                                        sx={{ fontSize: "12px", mb: 1 }}
                                      >
                                        GVM
                                      </Typography>
                                      <Field
                                        className="textField w-100"
                                        name="gvw"
                                        placeHolder="Enter GVM"
                                      />
                                    </Grid>
                                    <Grid item sx={{ width: "40%" }}>
                                      <Typography
                                        className={Styles.inputTitle}
                                        sx={{ fontSize: "12px", mb: 1 }}
                                      >
                                        Seating Capacity
                                      </Typography>
                                      <Field
                                        className="textField w-100"
                                        name="seatingCapacity"
                                        placeHolder="Enter Seating Capacity"
                                      />
                                    </Grid>
                                  </Grid>
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.6} sx={{ mb: 1 }}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    Registration Year
                                  </Typography>
                                  <Field
                                    className="textField w-100"
                                    name="registrationYear"
                                    placeHolder="Enter Registration Year"
                                  />
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.5} sx={{ mb: 1 }}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    Fuel Type
                                  </Typography>
                                  <Autocomplete
                                    className="AutoComplete_InputBox"
                                    name="fuelType"
                                    options={fuelType}
                                    value={fuelTypeValue}
                                    onInputChange={(e, v) =>
                                      setFuelTypeValue(v)
                                    }
                                    onChange={(e, v) => {
                                      setFieldValue("fuelType", v?._id);
                                      setFuelTypeValue(v?.label);
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        placeholder="Select Fuel Type"
                                      />
                                    )}
                                    isOptionEqualToValue={(option, value) =>
                                      option.fuelType === value
                                    }
                                    disabled={editableData ? true : false}
                                  />
                                </Grid>
                              </Grid>
                            </TabPanel>
                            <TabPanel value={4}>
                              <Grid container spacing={2} mt={1}>
                                <Grid item xs={12} sm={3.5}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    OD Policy Start Date
                                  </Typography>
                                  <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                  >
                                    <DatePicker
                                      name="odPolicyStartDate"
                                      format="DD/MM/YYYY"
                                      className="Date_Picker w-100"
                                      onChange={(e) =>
                                        OdPolicyStDateFunction(e)
                                      }
                                      value={dayjs(odPolicyStartDate)}
                                    />
                                  </LocalizationProvider>
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.6}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    OD Policy Period
                                  </Typography>
                                  <Select
                                    className="AutoComplete_InputBox w-100"
                                    name="odPolicyPeriod"
                                    value={values?.odPolicyPeriod}
                                    onChange={OdPolicyPeriodFunction}
                                    placeholder="Select Policy Period"
                                  >
                                    {OdPolicyPeriodController.map((e) => (
                                      <MenuItem value={e.value} key={e.value}>
                                        {e.label}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.5}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    OD Policy End Date
                                  </Typography>
                                  <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                  >
                                    <DatePicker
                                      format="DD/MM/YYYY"
                                      name="odPolicyEndDate"
                                      className="Date_Picker w-100"
                                      value={dayjs(odPolicyEndDateValue)}
                                      onChange={(e) =>
                                        setFieldValue("odPolicyEndDate", e?.$d)
                                      }
                                    />
                                  </LocalizationProvider>
                                </Grid>
                                <Grid item xs={12} sm={3.5}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    TP Policy Start Date
                                  </Typography>
                                  <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                  >
                                    <DatePicker
                                      format="DD/MM/YYYY"
                                      name="tpPolicyStartDate"
                                      className="Date_Picker w-100"
                                      onChange={(e) =>
                                        TPPolicyStDateFunction(e)
                                      }
                                      value={dayjs(tpPolicyStartDate)}
                                    />
                                  </LocalizationProvider>
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.6}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    TP Policy Period
                                  </Typography>
                                  <Select
                                    className="AutoComplete_InputBox w-100"
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    name="tpPolicyPeriod"
                                    value={values?.tpPolicyPeriod}
                                    placeholder="Select Policy Period"
                                    onChange={TpPolicyPeriodFunction}
                                  >
                                    {OdPolicyPeriodController.map((e) => (
                                      <MenuItem value={e.value} key={e.value}>
                                        {e.label}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.5}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    TP Policy End Date
                                  </Typography>
                                  <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                  >
                                    <DatePicker
                                      format="DD/MM/YYYY"
                                      name="tpPolicyEndDate"
                                      className="Date_Picker w-100"
                                      value={dayjs(tpPolicyDate)}
                                      onChange={(e) =>
                                        setFieldValue("tpPolicyEndDate", e?.$d)
                                      }
                                    />
                                  </LocalizationProvider>
                                </Grid>
                              </Grid>
                            </TabPanel>
                            <TabPanel value={5}>
                              <Grid container spacing={2} mt={1}>
                                <Grid item xs={12} sm={3.5}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    OD Disc
                                  </Typography>
                                  <Field
                                    className="textField w-100"
                                    name="odDisc"
                                    type="number"
                                    placeHolder="Enter OD Disc"
                                  />
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.6}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    OD Premium
                                  </Typography>
                                  <Field
                                    className="textField w-100"
                                    name="odPremium"
                                    type="number"
                                  />
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.5}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    TP Premium
                                  </Typography>
                                  <Field
                                    className="textField w-100"
                                    name="tpPremium"
                                    type="number"
                                    placeHolder="Enter TP Premium"
                                  />
                                </Grid>
                                <Grid item xs={12} sm={3.5}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    Net Premium
                                  </Typography>
                                  <Field
                                    className="textField w-100"
                                    name="netPremium"
                                    type="number"
                                    placeHolder="Enter Net Premium"
                                  />
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.6}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    Total Premium
                                  </Typography>
                                  <Field
                                    className="textField w-100"
                                    name="totalPremium"
                                    type="number"
                                    placeHolder="Enter Total Premium"
                                  />
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.5}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    PA Cover
                                  </Typography>
                                  <Field
                                    className="textField w-100"
                                    name="paCover"
                                    placeHolder="Enter PA Cover"
                                  />
                                </Grid>
                              </Grid>
                            </TabPanel>
                          </TabContext>

                          <Grid container spacing={1} sx={{ p: 3 }}>
                            {/* <Grid item xs={12} sm={2}>
                            <button className="w-100 TabelButton" onClick={() => setOpenEditPolicyDrawer(false)}>
                              Cancel
                            </button>
                          </Grid> */}
                            <Grid
                              item
                              xs={12}
                              sm={12}
                              sx={{
                                display: value === 5 ? "none" : "flex",
                                justifyContent: "end",
                              }}
                            >
                              <Button
                                disabled={disableOne}
                                sx={{ display: disableOne ? "none" : "block" }}
                                className="Common_Button"
                                onClick={(e) => handleChangePerTap(e, value)}
                              >
                                Next
                              </Button>
                            </Grid>
                            <Grid
                              item
                              xs={12}
                              sm={12}
                              sx={{
                                display:
                                  value === 5 && !disableOne ? "flex" : "none",
                                justifyContent: "end",
                              }}
                            >
                              <button
                                className={Styles.Update_Button}
                                type="submit"
                                // onClick={() => onSubmit(values)}
                              >
                                Update
                              </button>
                            </Grid>
                          </Grid>
                        </Box>
                      ) : null}
                      {!(selectedData?.status === PolicyFilterTypes[1].value) ||
                      editType === "CommonEdit" ? (
                        <>
                          <Box
                            sx={{
                              borderBottom: "1px solid #EAECF0",
                              padding: "0 15px",
                            }}
                          >
                            <Typography mt={3} className={Styles.formTitleHead}>
                              Policy Details
                            </Typography>

                            <Stack direction={"row"}>
                              <Grid container spacing={2} mt={1}>
                                <Grid item xs={12} sm={3.5}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    User Name
                                  </Typography>
                                  <Autocomplete
                                    className="AutoComplete_InputBox"
                                    name="userId"
                                    options={userDetails}
                                    value={userValue}
                                    onInputChange={(e, v) => setUserValue(v)}
                                    onChange={(e, v) => {
                                      setFieldValue("userId", v?._id);
                                      setSelectedUserId(v?._id);
                                      setUserValue(v?.label);
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        placeholder="Select User"
                                      />
                                    )}
                                    isOptionEqualToValue={(option, value) =>
                                      option?.label === value
                                    }
                                    renderOption={(props, option) => (
                                      <li {...props} key={option._id}>
                                        {option.name +
                                          " - " +
                                          option.mobileNumber +
                                          " - " +
                                          option.email}
                                      </li>
                                    )}
                                    disabled={editableData ? true : false}
                                  />
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.6}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    Login ID
                                  </Typography>
                                  <Autocomplete
                                    name="loginIdFull"
                                    disablePortal
                                    className="AutoComplete_InputBox"
                                    id="combo-box-demo"
                                    value={selectedLoginPortal}
                                    options={loginPortalDetails}
                                    onChange={(e, v) => {
                                      setSelectedLoginPortal(v?.loginPortal);

                                      setFieldValue(
                                        "loginIdFull",
                                        v?.loginPortal
                                      );
                                    }}
                                    renderOption={(props, option) => (
                                      <li {...props} key={option._id}>
                                        {option.loginPortal}
                                      </li>
                                    )}
                                    getOptionLabel={(option) => {
                                      // console.log("option  ", option);
                                      return typeof option === "object" &&
                                        option !== null
                                        ? option.loginPortal || "Unknown"
                                        : option;
                                    }}
                                    disabled={editableData ? true : false}
                                    isOptionEqualToValue={(e, v) =>
                                      e.loginPortal === v
                                    }
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        placeholder="Select Login ID"
                                      />
                                    )}
                                  />
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.5}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    Policy Number
                                  </Typography>
                                  <Field
                                    name="policyNumber"
                                    className="textField w-100"
                                    placeHolder="Enter Policy Number"
                                    disabled={editableData ? true : false}
                                  />
                                </Grid>
                                <Grid item xs={12} sm={3.5} sx={{ mb: 1 }}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    Issue Date
                                  </Typography>
                                  <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                  >
                                    <DatePicker
                                      format="DD/MM/YYYY"
                                      name="issueDate"
                                      className="Date_Picker w-100"
                                      defaultValue={
                                        formType === "edit"
                                          ? dayjs(selectedData?.issueDate)
                                          : null
                                      }
                                      onChange={(e) =>
                                        setFieldValue("issueDate", e.$d)
                                      }
                                      disabled={editableData ? true : false}
                                    />
                                  </LocalizationProvider>
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.6} sx={{ mb: 1 }}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    Company
                                  </Typography>
                                  <Autocomplete
                                    className="AutoComplete_InputBox"
                                    name="companyId"
                                    options={companyDetails}
                                    value={companyValue}
                                    onChange={(e, v) => {
                                      setFieldValue("companyId", v?._id);
                                      setSelectedCompanyId(v?._id);
                                      setCompanyValue(v?.label);
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        placeholder="Select Company"
                                      />
                                    )}
                                    isOptionEqualToValue={(option, value) =>
                                      option?.label === value
                                    }
                                    renderOption={(props, option) => (
                                      <li {...props} key={option._id}>
                                        {option.shortName}
                                      </li>
                                    )}
                                    disabled={editableData ? true : false}
                                  />
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.5} sx={{ mb: 1 }}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    Policy Type
                                  </Typography>
                                  <Autocomplete
                                    className="AutoComplete_InputBox"
                                    name="policyTypeId"
                                    options={policyTypeDetails}
                                    value={policyTypeValue}
                                    onInputChange={(e, v) =>
                                      setPolicyTypeValue(v)
                                    }
                                    onChange={(e, v) => {
                                      setFieldValue("policyTypeId", v?._id);
                                      setPolicyTypeValue(v?.label);
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        placeholder="Select Policy Type"
                                      />
                                    )}
                                    isOptionEqualToValue={(option, value) =>
                                      option.policyType === value
                                    }
                                    disabled={editableData ? true : false}
                                  />
                                </Grid>
                                {/* <Grid item xs={12} sm={0.7} /> */}
                                <Grid item xs={12} sm={3.5} sx={{ mb: 1 }}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    Product
                                  </Typography>
                                  <Autocomplete
                                    className="AutoComplete_InputBox"
                                    name="productId"
                                    options={productDetails}
                                    value={productValue}
                                    onInputChange={(e, v) => setProductValue(v)}
                                    onChange={(e, v) => {
                                      setFieldValue("productId", v?._id);
                                      setProductIdValue(v?._id);
                                      setProductValue(v?.label);
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        placeholder="Select Product"
                                      />
                                    )}
                                    isOptionEqualToValue={(option, value) =>
                                      option.product === value
                                    }
                                    disabled={editableData ? true : false}
                                  />
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.6} sx={{ mb: 1 }}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    Sub Product
                                  </Typography>
                                  <Autocomplete
                                    className="AutoComplete_InputBox"
                                    name="subProductId"
                                    options={subProductDetails}
                                    value={subProductValue}
                                    onInputChange={(e, v) =>
                                      setSubProductValue(v)
                                    }
                                    onChange={(e, v) => {
                                      setFieldValue("subProductId", v?._id);
                                      setSubProductIdValue(v?._id);
                                      setSubProductValue(v?.label);
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        placeholder="Select Sub Product"
                                      />
                                    )}
                                    isOptionEqualToValue={(option, value) =>
                                      option.subProduct === value
                                    }
                                    disabled={editableData ? true : false}
                                  />
                                </Grid>
                                <Grid item xs={12} sm={3.5} />
                                {/* <Grid item xs={12} sm={0.7} /> */}
                                <Grid item xs={12} sm={3.5} sx={{ mb: 2 }}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    Booking Code
                                  </Typography>
                                  <Autocomplete
                                    className="AutoComplete_InputBox"
                                    name="policyTypeId"
                                    options={bookingCodeDetails}
                                    value={bookingCodeValue}
                                    onInputChange={(e, v) =>
                                      setBookingCodeValue(v)
                                    }
                                    onChange={(e, v) => {
                                      setFieldValue(
                                        "bookingCodeId",
                                        v?.bookingCodeId._id
                                      );
                                      setBookingCodeValue(v?.label);
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        placeholder="Select Booking Code"
                                      />
                                    )}
                                    isOptionEqualToValue={(option, value) =>
                                      option.bookingCode === value
                                    }
                                    disabled={editableData ? true : false}
                                  />
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.6} sx={{ mb: 1 }}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    Sub Booking Code
                                  </Typography>
                                  <Autocomplete
                                    className="AutoComplete_InputBox"
                                    name="subBookingCodeId"
                                    options={subBookingCodeDetails}
                                    value={subBookingCodeValue}
                                    onInputChange={(e, v) =>
                                      setSubBookingCodeValue(v)
                                    }
                                    onChange={(e, v) => {
                                      setFieldValue("subBookingCodeId", v?._id);
                                      setSubBookingCodeValue(v?.label);
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        placeholder="Select Sub Booking"
                                      />
                                    )}
                                    isOptionEqualToValue={(option, value) =>
                                      option.subBookingCode === value
                                    }
                                    disabled={editableData ? true : false}
                                  />
                                </Grid>
                              </Grid>
                            </Stack>
                          </Box>
                          <Box
                            sx={{
                              borderBottom: "1px solid #EAECF0",
                              padding: "0 15px",
                              display: showRejectField ? "flex" : "none",
                            }}
                          >
                            <Typography mt={3} className={Styles.formTitleHead}>
                              Rejected
                            </Typography>

                            <Stack direction={"row"}>
                              <Grid container spacing={2} mt={1}>
                                <Grid item xs={12} sm={3.5} sx={{ mb: 2 }}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    Reason
                                  </Typography>
                                  <Autocomplete
                                    className="AutoComplete_InputBox"
                                    options={[
                                      {
                                        label: "Policy Number Mismatching",
                                        id: 1,
                                      },
                                      { label: "Other Agent Policy", id: 2 },
                                    ]}
                                    onChange={(e, v) =>
                                      setFieldValue("rejectedReason", v.label)
                                    }
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        placeholder="Select Reason"
                                      />
                                    )}
                                  ></Autocomplete>
                                </Grid>
                                <Grid item xs={12} sm={0.7}></Grid>
                                <Grid item xs={12} sm={3} sx={{ mb: 1 }}>
                                  <Button
                                    onClick={() => RejectedFunction(values)}
                                    variant="outlined"
                                    color="error"
                                    sx={{
                                      width: {
                                        xs: "100%",
                                        sm: "40%",
                                        backgroundColor: "red",
                                        height: "43px",
                                        borderRadius: "22px",
                                        marginTop: "23px",
                                        color: "white",
                                        "&:hover": {
                                          color: "red",
                                        },
                                      },
                                    }}
                                  >
                                    Reject
                                  </Button>
                                </Grid>
                              </Grid>
                            </Stack>
                          </Box>
                          <Box
                            sx={{
                              borderBottom: "1px solid #EAECF0",
                              padding: "0 15px",
                            }}
                          >
                            <Typography mt={3} className={Styles.formTitleHead}>
                              Customer Details
                            </Typography>

                            <Stack direction={"row"}>
                              <Grid container spacing={2} mt={1} mb={2}>
                                <Grid item xs={12} sm={3.5}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    Customer Name
                                  </Typography>
                                  <Field
                                    className="textField w-100"
                                    name="customerName"
                                    placeHolder="Enter Customer Name"
                                    disabled={editableData ? true : false}
                                  />
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.6}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    Mobile Number
                                  </Typography>
                                  <Field
                                    className="textField w-100"
                                    name="mobileNumber"
                                    placeHolder="Enter Mobile Number"
                                    disabled={editableData ? true : false}
                                  />
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.5}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    Email
                                  </Typography>
                                  <Field
                                    className="textField w-100"
                                    name="email"
                                    placeHolder="Enter Email"
                                    disabled={editableData ? true : false}
                                  />
                                </Grid>
                              </Grid>
                            </Stack>
                          </Box>
                          <Box
                            sx={{
                              borderBottom: "1px solid #EAECF0",
                              padding: "0 15px",
                            }}
                          >
                            <Typography mt={3} className={Styles.formTitleHead}>
                              Vehicle Details
                            </Typography>

                            <Stack direction={"row"}>
                              <Grid container spacing={2} mt={1} mb={2}>
                                <Grid item xs={12} sm={1.75}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    Registration Number
                                  </Typography>
                                  <Field
                                    className="textField w-100"
                                    name="registrationNumber"
                                    placeHolder="Enter Registration Number"
                                    disabled={editableData ? true : false}
                                    onBlur={
                                      (e) => checkRTO(rtoList, e.target.value) //Changes by Arun
                                    }
                                  />
                                </Grid>
                                <Grid item xs={12} sm={1.75}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    RTO
                                  </Typography>
                                  <Autocomplete
                                    className="AutoComplete_InputBox"
                                    name="rtoId"
                                    options={rtoListDropdown}
                                    value={rtoValue}
                                    onChange={(e, v) => {
                                      setFieldValue("rtoId", v?._id);
                                      setRtoValue(v?.label);
                                    }}
                                    // changes by somesh
                                    renderOption={(props, option) => (
                                      <li {...props} key={option._id}>
                                        {option.label}
                                      </li>
                                    )}
                                    clearIcon={true}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        placeholder="Select RTO"
                                      />
                                    )}
                                    disabled={editableData ? true : false}
                                  />
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.6}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    Make
                                  </Typography>
                                  <Autocomplete
                                    className="AutoComplete_InputBox"
                                    name="make"
                                    options={vehicleMakeDetails}
                                    value={vehicleValue}
                                    onChange={(e, v) => {
                                      setFieldValue("make", v?._id);
                                      setVehicleValue(v?.label);
                                    }}
                                    clearIcon={false}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        placeholder="Select Make"
                                      />
                                    )}
                                    isOptionalEqualToValue={(option, value) =>
                                      option.vehicleMake === value
                                    }
                                    disabled={editableData ? true : false}
                                  />
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.5}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    Model
                                  </Typography>
                                  <Field
                                    className="textField w-100"
                                    name="model"
                                    placeHolder="Enter Model"
                                    disabled={editableData ? true : false}
                                  />
                                </Grid>
                                <Grid item xs={12} sm={3.5} sx={{ mb: 1 }}>
                                  <Grid container spacing={1}>
                                    <Grid item sx={{ width: "30%" }}>
                                      <Typography
                                        className={Styles.inputTitle}
                                        sx={{ fontSize: "12px", mb: 1 }}
                                      >
                                        CC
                                      </Typography>
                                      <Field
                                        className="textField w-100"
                                        name="cc"
                                        placeHolder="Enter CC"
                                        disabled={editableData ? true : false}
                                      />
                                    </Grid>
                                    <Grid item sx={{ width: "30%" }}>
                                      <Typography
                                        className={Styles.inputTitle}
                                        sx={{ fontSize: "12px", mb: 1 }}
                                      >
                                        GVM
                                      </Typography>
                                      <Field
                                        className="textField w-100"
                                        name="gvw"
                                        placeHolder="Enter GVM"
                                        disabled={editableData ? true : false}
                                      />
                                    </Grid>
                                    <Grid item sx={{ width: "40%" }}>
                                      <Typography
                                        className={Styles.inputTitle}
                                        sx={{ fontSize: "12px", mb: 1 }}
                                      >
                                        Seating Capacity
                                      </Typography>
                                      <Field
                                        className="textField w-100"
                                        name="seatingCapacity"
                                        placeHolder="Enter Seating Capacity"
                                        disabled={editableData ? true : false}
                                      />
                                    </Grid>
                                  </Grid>
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.6} sx={{ mb: 1 }}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    Registration Year
                                  </Typography>
                                  <Field
                                    className="textField w-100"
                                    name="registrationYear"
                                    placeHolder="Enter Registration Year"
                                  />
                                </Grid>

                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.5} sx={{ mb: 1 }}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    Fuel Type
                                  </Typography>
                                  <Autocomplete
                                    className="AutoComplete_InputBox"
                                    name="fuelType"
                                    options={fuelType}
                                    value={fuelTypeValue}
                                    onInputChange={(e, v) =>
                                      setFuelTypeValue(v)
                                    }
                                    onChange={(e, v) => {
                                      setFieldValue("fuelType", v?._id);
                                      setFuelTypeValue(v?.label);
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        placeholder="Select Fuel Type"
                                      />
                                    )}
                                    isOptionEqualToValue={(option, value) =>
                                      option.fuelType === value
                                    }
                                    disabled={editableData ? true : false}
                                  />
                                </Grid>
                              </Grid>
                            </Stack>
                          </Box>
                          <Box
                            sx={{
                              borderBottom: "1px solid #EAECF0",
                              padding: "0 15px",
                            }}
                          >
                            <Typography mt={3} className={Styles.formTitleHead}>
                              OD Policy Date
                            </Typography>

                            <Stack direction={"row"}>
                              <Grid container spacing={2} mt={1} mb={2}>
                                <Grid item xs={12} sm={3.5}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    OD Policy Start Date
                                  </Typography>
                                  <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                  >
                                    <DatePicker
                                      name="odPolicyStartDate"
                                      format="DD/MM/YYYY"
                                      className="Date_Picker w-100"
                                      onChange={(e) =>
                                        OdPolicyStDateFunction(e)
                                      }
                                      value={dayjs(odPolicyStartDate)}
                                      disabled={editableData ? true : false}
                                    />
                                  </LocalizationProvider>
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.6}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    OD Policy Period
                                  </Typography>
                                  <Select
                                    className="AutoComplete_InputBox w-100"
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    name="odPolicyPeriod"
                                    value={values?.odPolicyPeriod}
                                    placeholder="Select Policy Period"
                                    onChange={OdPolicyPeriodFunction}
                                    disabled={editableData ? true : false}
                                  >
                                    {OdPolicyPeriodController.map((e) => (
                                      <MenuItem value={e.value} key={e.value}>
                                        {e.label}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.5}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    OD Policy End Date
                                  </Typography>

                                  <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                  >
                                    <DatePicker
                                      format="DD/MM/YYYY"
                                      name="odPolicyEndDate"
                                      className="Date_Picker w-100"
                                      value={dayjs(odPolicyEndDateValue)}
                                      onChange={(e) =>
                                        setFieldValue("odPolicyEndDate", e?.$d)
                                      }
                                      disabled={editableData ? true : false}
                                    />
                                  </LocalizationProvider>
                                </Grid>
                              </Grid>
                            </Stack>
                          </Box>
                          <Box
                            sx={{
                              borderBottom: "1px solid #EAECF0",
                              padding: "0 15px",
                            }}
                          >
                            <Typography mt={3} className={Styles.formTitleHead}>
                              TP Policy Date
                            </Typography>

                            <Stack direction={"row"}>
                              <Grid container spacing={2} mt={1} mb={2}>
                                <Grid item xs={12} sm={3.5}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    TP Policy Start Date
                                  </Typography>
                                  <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                  >
                                    <DatePicker
                                      format="DD/MM/YYYY"
                                      name="tpPolicyStartDate"
                                      className="Date_Picker w-100"
                                      onChange={(e) =>
                                        TPPolicyStDateFunction(e)
                                      }
                                      value={dayjs(tpPolicyStartDate)}
                                      disabled={editableData ? true : false}
                                    />
                                  </LocalizationProvider>
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.6}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    TP Policy Period
                                  </Typography>
                                  <Select
                                    className="AutoComplete_InputBox w-100"
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    name="tpPolicyPeriod"
                                    placeholder="Select Policy Period"
                                    value={values?.tpPolicyPeriod}
                                    onChange={TpPolicyPeriodFunction}
                                    disabled={editableData ? true : false}
                                  >
                                    {OdPolicyPeriodController.map((e) => (
                                      <MenuItem value={e.value} key={e.value}>
                                        {e.label}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.5}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    TP Policy End Date
                                  </Typography>

                                  <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                  >
                                    <DatePicker
                                      format="DD/MM/YYYY"
                                      name="tpPolicyEndDate"
                                      className="Date_Picker w-100"
                                      value={dayjs(tpPolicyDate)}
                                      onChange={(e) =>
                                        setFieldValue("tpPolicyEndDate", e?.$d)
                                      }
                                      disabled={editableData ? true : false}
                                    />
                                  </LocalizationProvider>
                                </Grid>
                              </Grid>
                            </Stack>
                          </Box>
                          <Box
                            sx={{
                              borderBottom: "1px solid #EAECF0",
                              padding: "0 15px",
                            }}
                          >
                            <Typography mt={3} className={Styles.formTitleHead}>
                              Premium
                            </Typography>

                            <Stack direction={"row"}>
                              <Grid container spacing={2} mt={1} mb={2}>
                                <Grid item xs={12} sm={3.5}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    OD Disc
                                  </Typography>
                                  <Field
                                    className="textField w-100"
                                    name="odDisc"
                                    type="number"
                                    placeHolder="Enter OD Disc"
                                  />
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.6}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    OD Premium
                                  </Typography>
                                  <Field
                                    className="textField w-100"
                                    name="odPremium"
                                    type="number"
                                  />
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.5}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    TP Premium
                                  </Typography>

                                  <Field
                                    className="textField w-100"
                                    name="tpPremium"
                                    type="number"
                                    placeHolder="Enter TP Premium"
                                  />
                                </Grid>
                                <Grid item xs={12} sm={3.5}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    Net Premium
                                  </Typography>
                                  <Field
                                    className="textField w-100"
                                    name="netPremium"
                                    type="number"
                                    placeHolder="Enter Net Premium"
                                  />
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.6}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    Total Premium
                                  </Typography>
                                  <Field
                                    className="textField w-100"
                                    name="totalPremium"
                                    type="number"
                                    placeHolder="Enter Total Premium"
                                  />
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.5}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    PA Cover
                                  </Typography>
                                  <Field
                                    className="textField w-100"
                                    name="paCover"
                                    placeHolder="Enter PA Cover"
                                  />
                                </Grid>
                              </Grid>
                            </Stack>
                          </Box>
                          <Box
                            sx={{
                              borderBottom: "1px solid #EAECF0",
                              padding: "0 15px",
                            }}
                          >
                            <Typography mt={3} className={Styles.formTitleHead}>
                              Payment Details
                            </Typography>

                            <Stack direction={"row"}>
                              <Grid container spacing={2} mt={1} mb={2}>
                                <Grid item xs={12} sm={3.5}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    Payment Mode
                                  </Typography>
                                  <Autocomplete
                                    className="AutoComplete_InputBox"
                                    name="paymentMode"
                                    disablePortal
                                    value={values?.paymentMode}
                                    id="combo-box-demo"
                                    options={PaymentDetails}
                                    isOptionEqualToValue={(option, value) =>
                                      option?.label === value
                                    }
                                    onChange={(e, v) => PaymentFunction(v)}
                                    clearIcon={false}
                                    renderInput={(params) => (
                                      <TextField {...params} />
                                    )}
                                    disabled={editableData ? true : false}
                                  />
                                </Grid>

                                {showPaymentMethod === 3 ? (
                                  <>
                                    <Grid item xs={12} sm={0.7} />
                                    <Grid item xs={12} sm={3.6}>
                                      <Typography
                                        className={Styles.inputTitle}
                                        sx={{ fontSize: "12px", mb: 1 }}
                                      >
                                        Cheque Number
                                      </Typography>
                                      <Field
                                        name="chequeNumber"
                                        placeHolder="Enter Cheque Number"
                                        className="textField w-100"
                                      />
                                    </Grid>
                                    <Grid item xs={12} sm={0.7} />
                                    <Grid item xs={12} sm={3.5}>
                                      <Typography
                                        className={Styles.inputTitle}
                                        sx={{ fontSize: "12px", mb: 1 }}
                                      >
                                        Cheque Date
                                      </Typography>
                                      <LocalizationProvider
                                        dateAdapter={AdapterDayjs}
                                      >
                                        <DatePicker
                                          format="DD/MM/YYYY"
                                          name="chequeDate"
                                          className="Date_Picker w-100"
                                          defaultValue={dayjs()}
                                          onChange={(e) => {
                                            setFieldValue("chequeDate", e.$d);
                                          }}
                                        />
                                      </LocalizationProvider>
                                    </Grid>
                                    <Grid item xs={12} sm={3.5}>
                                      <Typography
                                        className={Styles.inputTitle}
                                        sx={{ fontSize: "12px", mb: 1 }}
                                      >
                                        Bank Name
                                      </Typography>
                                      <Field
                                        className="textField w-100"
                                        name="bankName"
                                        placeHolder="Enter Bank Name"
                                      />
                                    </Grid>
                                  </>
                                ) : null}

                                {selectedData?.status ===
                                PolicyFilterTypes[2].value ? (
                                  <>
                                    <Grid item xs={12} sm={1}></Grid>
                                    <Grid item xs={12} sm={4.5}></Grid>
                                    <Grid
                                      item
                                      sx={{
                                        p: 2,
                                        display: editableData
                                          ? "block"
                                          : "none",
                                        marginTop: "30px",
                                        justifyContent: "end",
                                      }}
                                      xs={12}
                                      sm={3}
                                    >
                                      {openViewCal ? (
                                        <Button
                                          className="Master_Card_create_Button w-100"
                                          variant="contained"
                                          onClick={() => {
                                            setOpenViewCal(!openViewCal);
                                          }}
                                          endIcon={<CalculateIcon />}
                                        >
                                          Close Calculations
                                        </Button>
                                      ) : (
                                        <Button
                                          className="Master_Card_create_Button w-100"
                                          variant="contained"
                                          onClick={() =>
                                            GetPayablePercentFunction()
                                          }
                                          endIcon={<CalculateIcon />}
                                        >
                                          View Calculations
                                        </Button>
                                      )}
                                    </Grid>
                                  </>
                                ) : null}
                              </Grid>
                            </Stack>
                          </Box>
                        </>
                      ) : null}

                      {openViewCal ? (
                        <>
                          <Box
                            sx={{
                              borderBottom: "1px solid #EAECF0",
                              padding: "0 15px",
                              paddingBottom: "20px",
                            }}
                          >
                            <Typography mt={3} className={Styles.formTitleHead}>
                              User Approved %
                            </Typography>
                            <Stack direction={"row"}>
                              <Grid container spacing={2} mt={1} mb={2}>
                                <Grid item xs={12} sm={3.5}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    OD Percentage
                                  </Typography>
                                  <Field
                                    name="userOdPercentage"
                                    placeHolder="User OD Percentage"
                                    className="textField w-100"
                                    value={values?.userOdPercentage || ""} //Changes by Arun
                                  />
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.6}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    TP Percentage
                                  </Typography>
                                  <Field
                                    name="userTpPercentage"
                                    className="textField w-100"
                                    placeHolder="User TP Percentage"
                                    value={values?.userTpPercentage || ""} //Changes by Arun
                                  />
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.5}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    NET Percentage
                                  </Typography>

                                  <Field
                                    name="userNetPercentage"
                                    className="textField w-100"
                                    placeHolder="User Net Percentage"
                                    value={values?.userNetPercentage || ""} //Changes by Arun
                                  />
                                </Grid>
                                <Grid item xs={12} sm={3.5}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    OD Amount
                                  </Typography>
                                  <Field
                                    name="userOdAmount"
                                    placeHolder="OD Amount"
                                    className="textField w-100"
                                  />
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.6}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    TP Amount
                                  </Typography>
                                  <Field
                                    name="userTpAmount"
                                    placeHolder="TP Amount"
                                    className="textField w-100"
                                  />
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.5}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    NET Amount
                                  </Typography>
                                  <Field
                                    name="userNetAmount"
                                    placeHolder="NET Amount"
                                    className="textField w-100"
                                  />
                                </Grid>
                                <Grid item xs={12} sm={3.5}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    TOTAL Payable
                                  </Typography>
                                  <Field
                                    name="userTotalPayable"
                                    placeHolder="Total Payable"
                                    className="textField w-100"
                                  />
                                </Grid>
                              </Grid>
                            </Stack>
                          </Box>
                          <Box
                            sx={{
                              borderBottom: "1px solid #EAECF0",
                              padding: "0 15px",
                              paddingBottom: "20px",
                            }}
                          >
                            <Typography mt={3} className={Styles.formTitleHead}>
                              Receivable %
                            </Typography>
                            <Stack direction={"row"}>
                              <Grid container spacing={2} mt={1} mb={2}>
                                <Grid item xs={12} sm={3.5}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    OD Percentage
                                  </Typography>
                                  <Field
                                    name="receivableOdPercentage"
                                    className="textField w-100"
                                    placeHolder="Receivable OD Percentage"
                                    value={values?.receivableOdPercentage || ""} //Changes by Arun
                                  />
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.6}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    TP Percentage
                                  </Typography>
                                  <Field
                                    name="receivableTpPercentage"
                                    className="textField w-100"
                                    placeHolder="Receivable TP Percentage"
                                    value={values?.receivableTpPercentage || ""} //Changes by Arun
                                  />
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.5}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    NET Percentage
                                  </Typography>

                                  <Field
                                    name="receivableNetPercentage"
                                    className="textField w-100"
                                    placeHolder="Receivable NET Percentage"
                                    value={
                                      values?.receivableNetPercentage || ""
                                    } //Changes by Arun
                                  />
                                </Grid>
                                <Grid item xs={12} sm={3.5}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    OD Amount
                                  </Typography>
                                  <Field
                                    name="receivableOdAmount"
                                    placeHolder="Receivable OD Amount"
                                    className="textField w-100"
                                  />
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.6}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    TP Amount
                                  </Typography>
                                  <Field
                                    name="receivableTpAmount"
                                    placeHolder="Receivable TP Amount"
                                    className="textField w-100"
                                  />
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.5}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    NET Amount
                                  </Typography>
                                  <Field
                                    name="receivableNetAmount"
                                    placeHolder="Receivable NET Amount"
                                    className="textField w-100"
                                  />
                                </Grid>
                                <Grid item xs={12} sm={3.5}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    TOTAL Payable
                                  </Typography>
                                  <Field
                                    name="receivableTotalPayabl"
                                    placeHolder="Receivable Total Payable"
                                    className="textField w-100"
                                  />
                                </Grid>
                              </Grid>
                            </Stack>
                          </Box>
                          <Box
                            sx={{
                              borderBottom: "1px solid #EAECF0",
                              padding: "0 15px",
                              paddingBottom: "20px",
                            }}
                          >
                            <Typography mt={3} className={Styles.formTitleHead}>
                              Branch %
                            </Typography>
                            <Stack direction={"row"}>
                              <Grid container spacing={2} mt={1} mb={2}>
                                <Grid item xs={12} sm={3.5}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    OD Percentage
                                  </Typography>
                                  <Field
                                    name="branchOdPercentage"
                                    placeHolder="Branch OD Percentage"
                                    className="textField w-100"
                                    value={values?.branchOdPercentage || ""} //Changes by Arun
                                  />
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.6}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    TP Percentage
                                  </Typography>
                                  <Field
                                    name="branchTpPercentage"
                                    placeHolder="Branch TP Percentage"
                                    className="textField w-100"
                                    value={values?.branchTpPercentage || ""} //Changes by Arun
                                  />
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.5}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    NET Percentage
                                  </Typography>

                                  <Field
                                    name="branchNetPercentage"
                                    className="textField w-100"
                                    placeHolder="Branch NET Percentage"
                                    value={values?.branchNetPercentage || ""} //Changes by Arun
                                  />
                                </Grid>
                                <Grid item xs={12} sm={3.5}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    OD Amount
                                  </Typography>
                                  <Field
                                    name="branchOdAmount"
                                    placeHolder="Branch OD Amount"
                                    className="textField w-100"
                                  />
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.6}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    TP Amount
                                  </Typography>
                                  <Field
                                    name="branchTpAmount"
                                    placeHolder="Branch TP Amount"
                                    className="textField w-100"
                                  />
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.5}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    NET Amount
                                  </Typography>
                                  <Field
                                    name="branchNetAmount"
                                    placeHolder="Branch NET Amount"
                                    className="textField w-100"
                                  />
                                </Grid>
                                <Grid item xs={12} sm={3.5}>
                                  <Typography
                                    className={Styles.inputTitle}
                                    sx={{ fontSize: "12px", mb: 1 }}
                                  >
                                    TOTAL Payable
                                  </Typography>
                                  <Field
                                    name="branchTotalPayabl"
                                    placeHolder="Branch Total Payable"
                                    className="textField w-100"
                                  />
                                </Grid>
                                <Grid item xs={12} sm={0.7} />
                                <Grid item xs={12} sm={3.6}>
                                  <Button
                                    endIcon={<CalculateIcon />}
                                    sx={{ marginTop: "30px" }}
                                    className="Master_Card_create_Button"
                                    variant="contained"
                                    onClick={() => CalaculteFunction(values)}
                                  >
                                    Calculate
                                  </Button>
                                </Grid>
                              </Grid>
                            </Stack>
                          </Box>
                        </>
                      ) : null}
                    </Form>
                  )}
                </Formik>
              </Grid>
            </Grid>
          </div>
        )}
        <Loader open={openLoader} />
      </div>
    </>
  );
};

export default EditSearchPolicy;

// && data.odDisc && data.odPremium && data.tpPremium && data.netPremium && data.totalPremium
